import React from "react";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
  DeleteButton,
  SizePerPageDropDown,
  ExportCSVButton,
} from "react-bootstrap-table";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "../../assets/css/LockList.css";
import TimeStamp from "react-timestamp";
import { fire, auth } from "../../firebase/index";
import NoDataFound from "../Errors/NoDataFound";
import Loading from "../../components/Loading/Loading";
import withAuthorization from "../../components/Authorization/withAuthorization";
import _ from "lodash";
// import cellEditFactory from "react-bootstrap-table2-editor";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";

import { customLog, timestampToDate, SUPER_ADMIN_DETAILS } from "../../variables/Variables";
import { confirmAlert } from "react-confirm-alert";
//css
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import DetailsButton from "./DetailsButton";
import TagInfoButton from "./TagInfoButton";
import Login2password from "./login2password";
import {
  Button,
  Modal,
  Form,
  FormGroup,
  Checkbox,
  TabPane,
} from "react-bootstrap";
import RegisterLock from "../Tutorial/RegisterLockGuide";
import LockGroupManagement from "../LockGroupManagement/LockGroupManagement";
import LocalizedStrings from "react-localization";
import { is } from "bluebird";
import GroupManagementNew from "../GroupManagementNew/GroupManagementNew";
import { DISABLED } from "@blueprintjs/core/lib/esm/common/classes";
import { ExportToCsv } from "export-to-csv";
import { ModalHeader } from "semantic-ui-react";

// import { black } from "material-ui/styles/colors";
// import AutoLockScrolling from "material-ui/internal/AutoLockScrolling";
//import localization
//Localization codes

let localizationStrings = new LocalizedStrings({
  en: {
    locklistTitle: "Locklist",
    descriptionTitle: "These are your registered locks ",
    descriptionSubtitle1:
      "To Register/Add New Locks, use eGeeTouch iOS or Android Mobile App. For more details, Refer to",
    descriptionSubtitle2: "",
    cannotRemove: "Locks from user groups cannot be removed from your locklist",
    doubleClickInstruc: "Double-click name to edit",
    groupLocksDesc: "Group Locks ",
    cannotDelete: "You're not allowed to delete group locks",
    exceededLockLimits:
      "Please delete some locks as you have exceeded plan limits",
    headerName: "Name",
    headerSerial: "Serial No. ",
    headerModel: "Model",
    headerShareMode: "Share Mode",
    headerShareBy: "Share By",
    headerAdmin: "Admin",
    headerAccess: "Access Status",
    headerBattery: "Battery Level",
    headerShareTimed: "Timed Access",
    headerPermission: "Permission",
    headerLastSyncDate: "Last Sync Date",
    headerTagInformation: "Tag Info",
    headerTagPasscodeInformation: "Tag / Passcode",
    headerpassword: "Password",
    headerStartTime: "Start Time",
    headerEndTime: "End Time",
    headerLastSyncLocation: "Last Sync Location",
    headerRecurring: "Recurring",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    nextPage: "First Page",
    prePage: "Pre page",
    firstPage: "Next page",
    lastPage: "Last page",
    confirmRetractTitle: "Confirm remove lock",
    confirmRetractMessage:
      " Users will not have access for the lock after it's being deleted",
    confirmRetractButton: "Confirm",
    cancelRetractButton: "Cancel",
    fullAccessTitle: "All-day Access",
    nonSharedLockTitle: "Non-Shared Lock",
    recurringNonSharedLockTitle: "Recurring Non-Shared Lock",
    recurringLockGroupLock: "Recurring Lock Group Access",
    recurringUserGroupLock: "Recurring User Group Access",
    multiApproveLockGroupLock: "Multi Approve Lock Group Access",
    multiApproveUserGroupLock: "Multi Approve User Group Access",
    multiApproveOneTimeAccessLockGroupLock:
      "Multi Approve & One Time Lock Group Access",
    multiApproveOneTimeAccessUserGroupLock:
      "Multi Approve & One Time Lock Group Access",
    oneTimeAccessLockGroupLock: "One Time Lock Group Access",
    oneTimeAccessUserGroupLock: "One Time User Group Access",
    multiApproveAccess: "Multi Approve Access",
    multiApproveOneTimeAccess: "Multi Approve & One Time Access",
    oneTimeAccess: "One Time Access",
    lockGroupAccess: "Lock Group Access",
    userGroupAccess: "User Group Access",
    removeSelected: "Remove Selected",
    registerLockGuide: "Add a Lock",
    lowBatteryLocksDetected: "Low Battery Locks Detected.",
    viewLocks: "View Locks",
    lowBatteryLocks: "Low Battery Locks",
    searchPlaceholder: "Search",
    noGroupLock: "You do not have any group locks",
    helpTitle: "Help",
    doNotShowCheckbox: "Don't show this pop up again",
    noDataTitle: "There is no data to display",
    lockNameChangeSuccess: "Lock name successfully changed !",
    lockNameChangeDenied:
      "You do not have permission to change the lock's name",
    lockNameEmpty: "Lock name cannot be empty !",
    lockNameLong: "Lock name is too long !",
    lockDeleted: "Lock has been deleted !",
    recurringDaySun: "Sun",
    recurringDayMon: "Mon",
    recurringDayTue: "Tue",
    recurringDayWed: "Wed",
    recurringDayThu: "Thu",
    recurringDayFri: "Fri",
    recurringDaySat: "Sat",
    everyday: "everyday",
    individualTab: "Individual",
    groupTab: "Lock Groups",
    headerGroupName: "Group Name",
    exportCSVTitle: "Export CSV",
    exportCSVHeader: "Export All Locks",
    exportBtnTitle: "Export",
    cancelExportBtnTitle: "Cancel",
    helpButtonLabel: "Help",
  },
  ja: {
    locklistTitle: "ハードウェアリスト",
    descriptionTitle: "スマートロック一覧",
    // descriptionSubtitle: "(新しいロックを登録/追加するには、eGeeTouchiOSまたはAndroidモバイルアプリを使用します。 詳細については、ヘルプ（？）を参照してください。)",
    // doubleClickInstruc: "名前の変更は該当欄をダブルクリックします",
    descriptionSubtitle1:
      "スマートロックの新規追加は、管理者のスマホアプリでご登録いただけます。詳細は",
    descriptionSubtitle2: "をご参照下さい。",
    cannotRemove:
      "ユーザーグループからのロックはロックリストから削除できません。",
    doubleClickInstruc: "名前の変更：該当欄をダブルクリックして変更します。",
    exceededLockLimits:
      "ご契約パッケージの登録制限数を超えました。プランをアップグレードをされるか、制限数内での登録で運用して下さい。",
    headerName: "名前",
    headerSerial: "シリアルNo",
    headerModel: "機種",
    headerShareMode: "シェアモード",
    headerShareBy: "シェア状況",
    headerShareTimed: "タイムアクセス",
    headerPermission: "承認",
    headerAccess: "アクセス状況",
    headerBattery: "電池残量",
    headerLastSyncDate: "アクセス日",
    headerLastSyncLocation: "ロケーション",
    headerRecurring: "曜日選択",
    resultTitle1: "表示中 ",
    resultTitle2: " に ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
    nextPage: "先頭ページ",
    prePage: "前ページ",
    firstPage: "次のページ",
    lastPage: "最後のページ",
    fullAccessTitle: "アクセス制限無し",
    nonSharedLockTitle: "共有していません",
    recurringNonSharedLockTitle: "曜日設定",
    recurringLockGroupLock: "定期的なロックグループアクセス",
    recurringUserGroupLock: "定期的なユーザーグループアクセス",
    multiApproveLockGroupLock: "マルチ承認ロックグループアクセス",
    multiApproveUserGroupLock: "複数承認ユーザーグループアクセス",
    multiApproveOneTimeAccessLockGroupLock:
      "マルチ承認およびワンタイムロックグループアクセス",
    multiApproveOneTimeAccessUserGroupLock:
      "複数承認とワンタイムユーザーグループアクセス",
    oneTimeAccessLockGroupLock: "ワンタイムロックグループアクセス",
    oneTimeAccessUserGroupLock: "ワンタイムユーザーグループアクセス",
    multiApproveAccess: "承認者追加",
    multiApproveOneTimeAccess: "承認者追加＆ワンタイム解錠",
    oneTimeAccess: "ワンタイム解錠",
    lockGroupAccess: "グループアクセスをロックする",
    userGroupAccess: "ユーザーグループアクセス",
    removeSelected: "削除",
    registerLockGuide: "ロックを追加する",
    lowBatteryLocksDetected: "充電残量少",
    viewLocks: "ハードウェア",
    lowBatteryLocks: "充電残量少",
    searchPlaceholder: "検索",
    helpTitle: "ヘルプ",
    confirmRetractTitle: "スマートロックへのアクセスを無効にしました。",
    confirmRetractMessage: "削除すると解錠が出来なくなります。",
    confirmRetractButton: "OK",
    cancelRetractButton: "キャンセル",
    doNotShowCheckbox: "メッセージを今後表示しない",
    noDataTitle: "表示するデータがありません。",
    lockNameChangeSuccess: "名称を変更しました。",
    lockNameChangeDenied: "ロック名を変更する権限がありません",
    lockNameEmpty: "名称を入力して下さい。",
    lockNameLong: "名称が制限文字数を超えています。",
    lockDeleted: "スマートロックを削除しました。",
    recurringDaySun: "日",
    recurringDayMon: "月",
    recurringDayTue: "火",
    recurringDayWed: "水",
    recurringDayThu: "木",
    recurringDayFri: "金",
    recurringDaySat: "土",
    everyday: "毎日（月～日）",
    individualTab: "個別登録",
    groupTab: "ロックグループ",
    groupLocksDesc: "スマートロックリスト",
    cannotDelete: "グループで登録しているロックは削除できません。",
    headerAdmin: "管理者",
    headerGroupName: "グループ名",
    headerTagInformation: "NFC利用状況",
    headerTagPasscodeInformation: "タグ / パスコード",
    headerpassword: "パスワード",
    headerStartTime: "開始時間",
    headerEndTime: "終了時間",
    noGroupLock: "グループロックはありません",
    exportCSVTitle: "CSV出力",
    exportCSVHeader: "すべてのロックをエクスポート",
    exportBtnTitle: "エクスポート",
    cancelExportBtnTitle: "キャンセル",
    helpButtonLabel: "ヘルプ",
  },
  es: {
    locklistTitle: "Lista de Candados",
    descriptionTitle: "Estos son tus candados registrados",
    descriptionSubtitle1:
      "Para agregar nuevos candados, usa la app eGeeTouch para iOS o Android. Más detalles en",
    descriptionSubtitle2: "",
    cannotRemove:
      "Los candados de grupos de usuarios no se pueden eliminar de su lista de candado",
    doubleClickInstruc: "Haz doble clic en el nombre para editar",
    groupLocksDesc: "Candados de Grupo",
    cannotDelete: "No tienes permiso para eliminar candados de grupo",
    exceededLockLimits:
      "Por favor, elimina algunos candados ya que has superado los límites del plan",
    headerName: "Nombre",
    headerSerial: "N° de Serie",
    headerModel: "Modelo",
    headerShareMode: "Modo de Compartición",
    headerShareBy: "Compartido Por",
    headerAdmin: "Administrador",
    headerAccess: "Estado de Acceso",
    headerBattery: "Nivel de Batería",
    headerShareTimed: "Acceso Temporal",
    headerPermission: "Permiso",
    headerLastSyncDate: "Última Fecha de Sincronización",
    headerTagInformation: "Información de Etiqueta",
    headerTagPasscodeInformation: "Etiqueta / Código de Acceso",
    headerpassword: "Contraseña",
    headerStartTime: "Hora de Inicio",
    headerEndTime: "Hora de Fin",
    headerLastSyncLocation: "Última Ubicación de Sincronización",
    headerRecurring: "Recurrente",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
    nextPage: "Primera Página",
    prePage: "Página Anterior",
    firstPage: "Página Siguiente",
    lastPage: "Última Página",
    confirmRetractTitle: "Confirmar eliminación del candado",
    confirmRetractMessage:
      "Los usuarios no tendrán acceso al candado después de ser eliminado",
    confirmRetractButton: "Confirmar",
    cancelRetractButton: "Cancelar",
    fullAccessTitle: "Acceso Todo el Día",
    nonSharedLockTitle: "Candado No Compartido",
    recurringNonSharedLockTitle: "Candado No Compartido Recurrente",
    recurringLockGroupLock: "Recurrente Acceso al Grupo de Candado",
    recurringUserGroupLock: "Recurrente Acceso al Grupo de Usuarios",
    multiApproveLockGroupLock:
      "Acceso de Grupo de Candado con Aprobación Múltiple",
    multiApproveUserGroupLock:
      "Acceso al Grupo de Usuarios con Aprobación Múltiple",
    multiApproveOneTimeAccessLockGroupLock:
      "Acceso de Grupo de Candado con Aprobación Múltiple y Única Vez",
    multiApproveOneTimeAccessUserGroupLock:
      "Acceso al Grupo de Usuarios con Aprobación Múltiple y Única Vez",
    oneTimeAccessLockGroupLock: "Acceso de Grupo de Candado por Única Vez",
    oneTimeAccessUserGroupLock: "Acceso al Grupo de Usuarios por Única Vez",
    multiApproveAccess: "Acceso de Múltiples Aprobaciones",
    multiApproveOneTimeAccess: "Aprobación Múltiple & Acceso Único",
    oneTimeAccess: "Acceso Único",
    lockGroupAccess: "Acceso de Candado Grupo",
    userGroupAccess: "Acceso al Grupo de Usuarios",
    removeSelected: "Eliminar Seleccion",
    registerLockGuide: "Agregar un Candado",
    lowBatteryLocksDetected: "Candados con Batería Baja Detectados.",
    viewLocks: "Ver Candados",
    lowBatteryLocks: "Candados con Batería Baja",
    searchPlaceholder: "Buscar",
    noGroupLock: "No tienes ningún candado de grupo",
    helpTitle: "Ayuda",
    doNotShowCheckbox: "No mostrar este mensaje nuevamente",
    noDataTitle: "No hay datos para mostrar",
    lockNameChangeSuccess: "¡Nombre del candado cambiado con éxito!",
    lockNameChangeDenied:
      "No tienes permiso para cambiar el nombre del candado",
    lockNameEmpty: "¡El nombre del candado no puede estar vacío!",
    lockNameLong: "¡El nombre del candado es demasiado largo!",
    lockDeleted: "¡El candado ha sido eliminado!",
    recurringDaySun: "Dom",
    recurringDayMon: "Lun",
    recurringDayTue: "Mar",
    recurringDayWed: "Mié",
    recurringDayThu: "Jue",
    recurringDayFri: "Vie",
    recurringDaySat: "Sáb",
    everyday: "todos los días",
    individualTab: "Individual",
    groupTab: "Grupos de Candados",
    headerGroupName: "Nombre del Grupo",
    exportCSVTitle: "Exportar CSV",
    exportCSVHeader: "Exportar Todas las Candados",
    exportBtnTitle: "Exportar",
    cancelExportBtnTitle: "Cancelar",
    helpButtonLabel: "Ayuda",
  },
});

//Inline CSS
const center = {
  textAlign: "center",
};
// const searchBar = {
//   position: "relative",
//   width: "300px",
//   borderRadius: "12px"
// };

//delete btn css
// const deletebtnStyle = {
//   width: "15%",
//   marginLeft: "80%",
//   position: "relative",
//   top: "-75px",
//   backgroundColor: "red",
//   textAlign: "center",
//   color: "white"
// };

class Locklist extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      locklistArray: [],
      grouplocklistArray: [],
      lowBatteryLockArray: [],
      searchFilter: "",
      loading: true,
      selectedLockKeysArray: [],
      isDeleteMode: false,
      _notificationSystem: null,
      isSuperAdmin: false,
      isAdmin: false,
      superAdminID: "",
      showPopup: false,
      showHelpPopup: false,
      popupTitle: "",
      popupImage: [],
      lowBatteryDetected: false,
      showLowBatteryPopup: false,
      isBatteryNotificationDisabled: false,
      checkboxChecked: false,
      showExportPopup: false,
      exportLocksArr: [],
      selectedLocks: [],

      // lockNameExist: false
    };
    //binding is prioritise loading this function before anything
    this.createCustomDeleteButton = this.createCustomDeleteButton.bind(this);
    // this.renderLocklistArray = this.renderLocklistArray.bind(this);
    this.snapshotToArray = this.snapshotToArray.bind(this);
    this.groupSnap = this.groupSnap.bind(this);

    this.handleChange = this.handleChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.saveCellChanges = this.saveCellChanges.bind(this);
    // this.handleDeleteButtonClick = this.handleDeleteButtonClick.bind(this)
    this.deleteLock = this.deleteLock.bind(this);
    this.renderDeleteBtn = this.renderDeleteBtn.bind(this);
    this.renderSizePerPageDropDown = this.renderSizePerPageDropDown.bind(this);
    this.onToggleDropDown = this.onToggleDropDown.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handleHelpPopupClose = this.handleHelpPopupClose.bind(this);
    this.handleHelpPopupOpen = this.handleHelpPopupOpen.bind(this);
    // this.collectBatteryData = this.collectBatteryData.bind(this);
    this.renderDetailsBtn = this.renderDetailsBtn.bind(this);
    this.groupRenderDetailsBtn = this.groupRenderDetailsBtn.bind(this);

    this.handleLowBatteryPopupOpen = this.handleLowBatteryPopupOpen.bind(this);
    this.handleLowBatteryPopupClose = this.handleLowBatteryPopupClose.bind(
      this,
    );
    this.reloadLocklist = this.reloadLocklist.bind(this);
    this.groupreloadLocklist = this.groupreloadLocklist.bind(this);
    this.renderRecurringSchedule = this.renderRecurringSchedule.bind(this);
    this.dateTimeFormat = this.dateTimeFormat.bind(this);
    this.createCustomExportCSVButton = this.createCustomExportCSVButton.bind(
      this,
    );
    this.handleExportCSV = this.handleExportCSV.bind(this);
  }

  // Resolves the superAdminUID — uses cached value from login if available,
  // falls back to Firebase lookup on page refresh when the cache is empty.
  resolveSuperAdminUID() {
    if (SUPER_ADMIN_DETAILS.UUID) {
      return Promise.resolve(SUPER_ADMIN_DETAILS.UUID);
    }
    const uid = auth.currentUser.uid;
    return fire
      .database()
      .ref("groupAccounts")
      .child(uid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          // Current user is the super admin
          SUPER_ADMIN_DETAILS.UUID = uid;
          return uid;
        }
        // Current user is an admin — scan to find their superAdminUID
        return fire
          .database()
          .ref("groupAccounts")
          .once("value")
          .then((allSnapshot) => {
            let found = "";
            if (allSnapshot.exists()) {
              outer: for (const superAdminKey in allSnapshot.val()) {
                const members = allSnapshot.val()[superAdminKey].members || {};
                for (const mKey in members) {
                  if (members[mKey].memberEmail === auth.currentUser.email) {
                    found = superAdminKey;
                    break outer;
                  }
                }
              }
            }
            SUPER_ADMIN_DETAILS.UUID = found;
            return found;
          });
      });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    this.reloadLocklist();
    this.groupreloadLocklist();

    // fire
    //   .database()
    //   .ref("groupAccounts/" + auth.currentUser.uid)
    //   .once("value")
    //   .then(snapshot => {
    //     if (snapshot.exists()) {
    //       this.setState({
    //         isSuperAdmin: true
    //       });
    //     }
    //   });

    // Resolve superAdminUID (cached from login or fetched on page refresh)
    this.resolveSuperAdminUID().then((superAdminUID) => {
      const isSuperAdmin = auth.currentUser.uid === superAdminUID;

      this.setState({
        isSuperAdmin: isSuperAdmin,
        isAdmin: !isSuperAdmin,
        superAdminID: superAdminUID,
      });

      // Check lock limit using targeted read
      fire
        .database()
        .ref("groupAccounts/" + superAdminUID + "/payment")
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            const maxUserLocks = snapshot.val().maxLocks;
            fire
              .database()
              .ref("MyAdminLocks/" + superAdminUID)
              .once("value")
              .then((snapshot) => {
                if (snapshot.numChildren() > maxUserLocks) {
                  this.showNotification(
                    localizationStrings.exceededLockLimits,
                    "error",
                    "tc",
                    0,
                  );
                }
              });
          }
        });
    });

    if (auth.currentUser !== null) {
      //! FOR LANGUAGE SETTINGS
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });

      //! FOR BATTERY NOTIFICATION
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("isBatteryNotificationDisabled")
        .on("value", (snapshot) => {
          if (snapshot.val() === null) {
            fire
              .database()
              .ref("userSettings")
              .child(auth.currentUser.uid)
              .update({
                isBatteryNotificationDisabled: false,
              });
          }

          this.setState({
            isBatteryNotificationDisabled: snapshot.val(),
            checkboxChecked: snapshot.val(),
          });
        });
    }

    // fire
    //   .database()
    //   .ref("userSettings")
    //   .child(auth.currentUser.uid)
    //   .once("value")
    //   .then(snapshot => {
    //     if (snapshot.exists()) {
    //       snapshot.forEach(snapshotChild => {
    //         if (
    //           snapshotChild.val().isBatteryNotificationDisabled !== null &&
    //           snapshotChild.val().isBatteryNotificationDisabled !== undefined
    //         ) {
    //           this.setState({
    //             isBatteryNotificationDisabled: snapshotChild.val()
    //               .isBatteryNotificationDisabled
    //           });
    //           console.log(snapshotChild.val().isBatteryNotificationDisabled);
    //         }
    //       });
    //     }
    //   })
    //   .then(() => {
    //     console.log(this.state.isBatteryNotificationDisabled);
    //   });

    // if (auth.currentUser !== null) {
    //   fire
    //     .database()
    //     .ref("userSettings")
    //     .once("value")
    //     .then(snapshot => {
    //       snapshot.forEach(snapshotChild => {
    //         const useruid = snapshotChild.key;
    //         if (
    //           snapshotChild.val().isBatteryNotificationDisabled === null ||
    //           snapshotChild.val().isBatteryNotificationDisabled === undefined
    //         ) {
    //           console.log(useruid);
    //           fire.database()
    //           .ref("userSettings")
    //           .child(useruid)
    //           .update({
    //             isBatteryNotificationDisabled: false
    //           })
    //         }
    //       });
    //     });
    // }
  }
  //pulling data for the locklist
  reloadLocklist() {
    this.resolveSuperAdminUID().then((superAdminUID) => {
    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        let tempArray = [];
        let lowBatteryArray = [];
        tempArray = this.snapshotToArray(snapshot);

        fire
          .database()
          .ref("GroupManagement")
          .child(superAdminUID)
          .once("value")
          .then((snapshot) => {
            const groupPromises = [];

            snapshot.forEach((childSnapshot) => {
              childSnapshot.forEach((grandchildSnapshot) => {
                const data = grandchildSnapshot.val();
                const groupMembers = data.groupMembers;
                const groupLocks = data.groupLocks;

                if (groupMembers && groupMembers[auth.currentUser.uid]) {
                  if (groupLocks) {
                    Object.values(groupLocks).forEach((lock) => {
                      tempArray.push(this.groupSnap({ ...lock, key: lock.snapID }));
                    });
                  }
                }
              });
            });

            if (tempArray.length === 0) {
              this.setState({ loading: false, locklistArray: [] });
              return;
            }

            // Batch all lockHardwareStatus reads in parallel
            const locksWithSerial = tempArray.filter((e) => e.ip45SerialNumber !== "");
            const batteryPromises = locksWithSerial.map((e) =>
              fire
                .database()
                .ref("lockHardwareStatus")
                .child(e.ip45SerialNumber)
                .once("value")
                .then((snapshots) => {
                  if (snapshots.exists() && e.ip45SerialNumber === snapshots.val().lockSerial) {
                    e["batteryLevel"] = snapshots.val().batteryLevel;
                  } else {
                    e["batteryLevel"] = "-";
                  }
                })
            );

            Promise.all(batteryPromises).then(() => {
              this.setState({ loading: false, locklistArray: tempArray });

              // Low battery notification — only for locks at ≤15%
              tempArray.forEach((e) => {
                if (e.batteryLevel !== "-" && e.batteryLevel !== undefined && e.batteryLevel <= 15) {
                  fire
                    .database()
                    .ref("AuditTrail")
                    .child(e.ip45SerialNumber)
                    .orderByChild("time")
                    .limitToLast(1)
                    .once("value")
                    .then((audittrail) => {
                      audittrail.forEach((audittrailData) => {
                        // eslint-disable-next-line no-unused-vars
                        const { batteryLevel, ...auditTrailFields } = audittrailData.val();
                        const mergeObject = Object.assign({}, e, auditTrailFields);
                        lowBatteryArray.push(mergeObject);
                        this.setState({
                          lowBatteryLockArray: lowBatteryArray,
                          lowBatteryDetected: true,
                          showLowBatteryPopup: !this.state.isBatteryNotificationDisabled,
                        });
                      });
                    });
                }
              });
            });
          });
      });
    }); // resolveSuperAdminUID
  }

  //displaying group locklist
  groupreloadLocklist() {
    var grouptempArray = [];
    var lowBatteryArray = [];

    this.resolveSuperAdminUID().then((superadminUID) => {
    fire
      .database()
      .ref("groupAccounts")
      .child(superadminUID)
      .child("userGroups")
      .child(auth.currentUser.uid)
      .child("groups")
      .once("value")
      .then((snapshot) => {
        if (!snapshot.exists()) return;

        const groupPromises = [];

        snapshot.forEach((groups) => {
          const grouping = groups.val();
          const groupRef = fire
            .database()
            .ref("GroupManagement")
            .child(superadminUID)
            .child(grouping.groupAdminUID)
            .child(grouping.groupID);

          const groupPromise = groupRef.once("value").then((groupSnapshot) => {
            if (!groupSnapshot.exists()) return;

            const groupName = groupSnapshot.val().groupName;
            const groupMembers = groupSnapshot.child("groupMembers").val() || {};
            const isMember = Object.values(groupMembers).some(
              (m) => m.memberUID == auth.currentUser.uid
            );
            if (!isMember) return;

            const groupLocks = groupSnapshot.child("groupLocks").val() || {};
            const newLocks = Object.values(groupLocks).map((lock) => {
              const lockData = this.groupSnap({ ...lock });
              lockData["groupName"] = [groupName];
              lockData["key"] = lock.snapID;
              return lockData;
            });

            grouptempArray = [...newLocks, ...grouptempArray];
          });

          groupPromises.push(groupPromise);
        });

        Promise.all(groupPromises).then(() => {
          if (grouptempArray.length === 0) {
            this.setState({ loading: false, grouplocklistArray: [] });
            return;
          }

          // Batch all lockHardwareStatus reads in parallel
          const locksWithSerial = grouptempArray.filter((e) => e.ip45SerialNumber !== "");
          const batteryPromises = locksWithSerial.map((e) =>
            fire
              .database()
              .ref("lockHardwareStatus")
              .child(e.ip45SerialNumber)
              .once("value")
              .then((snapshots) => {
                if (snapshots.exists() && e.ip45SerialNumber === snapshots.val().lockSerial) {
                  e["batteryLevel"] = snapshots.val().batteryLevel;
                } else {
                  e["batteryLevel"] = "-";
                }
              })
          );

          Promise.all(batteryPromises).then(() => {
            this.setState({ loading: false, grouplocklistArray: grouptempArray });

            // Low battery notification — only for locks at ≤15%
            grouptempArray.forEach((e) => {
              if (e.batteryLevel !== "-" && e.batteryLevel !== undefined && e.batteryLevel <= 15) {
                fire
                  .database()
                  .ref("AuditTrail")
                  .child(e.ip45SerialNumber)
                  .orderByChild("time")
                  .limitToLast(1)
                  .once("value")
                  .then((audittrail) => {
                    audittrail.forEach((audittrailData) => {
                      // eslint-disable-next-line no-unused-vars
                      const { batteryLevel, ...auditTrailFields } = audittrailData.val();
                      const mergeObject = Object.assign({}, e, auditTrailFields);
                      lowBatteryArray.push(mergeObject);
                      this.setState({
                        lowBatteryLockArray: lowBatteryArray,
                        lowBatteryDetected: true,
                        showLowBatteryPopup: !this.state.isBatteryNotificationDisabled,
                      });
                    });
                  });
              }
            });
          });
        });
      });
    }); // resolveSuperAdminUID
  }

  dateTimeFormat(time) {
    customLog(time);
    customLog(localizationStrings.getLanguage());
    if (localizationStrings.getLanguage() === "ja") {
      customLog(new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(time));
      customLog(
        new Intl.DateTimeFormat("ja-JP", {
          hour: "2-digit",
          minute: "2-digit",
        }).format(time),
      );
      customLog(Date.now());
      // var japanDate = new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(
      //   time
      // );
      // var japanTime = new Intl.DateTimeFormat("ja-JP", {
      //   hour: "2-digit",
      //   minute: "2-digit"
      // }).format(time);
      // return japanDate + japanTime;
      var japanDate =
        new Intl.DateTimeFormat("ja-JP", {
          year: "numeric",
        }).format(time) +
        new Intl.DateTimeFormat("ja-JP", {
          month: "numeric",
        }).format(time) +
        new Intl.DateTimeFormat("ja-JP", {
          day: "numeric",
        }).format(time);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hourCycle: "h12",
        hour: "numeric",
        minute: "2-digit",
      }).format(time);
      return japanDate + " " + japanTime;
    } else {
      return new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        // second: "2-digit"
      }).format(time);

      // return <TimeStamp time={time / 1000} format="full" />;

      // const timestamp = (
      //   <TimeStamp time={time / 1000} format="full" includeDay />
      // );
      // return timestamp;
    }
  }

  showNotification(msg, lvl, position, duration) {
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: duration,
    });
  }

  getLockModelName(type) {
    let lock = "Lock Model Unknown";
    if (type === 1) {
      lock = "Debossed Lock";
    } else if (type === 2) {
      lock = "TSA Travel Lock";
    } else if (type === 3) {
      lock = "Padlock with NFC and Bluetooth";
    } else if (type === 4) {
      lock = "IP45 Padlock";
    } else if (type === 10) {
      lock = "IP66 Padlock";
    } else if (type === 7 || type === 8 || type === 9) {
      lock = "Lock Out Tag Out";
    } else if (type === 11) {
      lock = "Anti-Cut Padlock";
    } else if (type === 12) {
      lock = "Heavy Duty Padlock";
    } else if (type === 13) {
      lock = "IP66 LOTO";
    }
    // IP45 Padlock

    return lock;
  }

  groupSnap = (snapshotValue) => {
    var item = snapshotValue;

    if (item.shareEndTime === 0 && item.shareStartTime === 0) {
      item["accessStatus"] = "All-day Access";
    } else {
      let startTime;
      let endTime;

      if (localizationStrings.getLanguage() === "ja") {
        startTime =
          new Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
          }).format(item.shareStartTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            month: "numeric",
          }).format(item.shareStartTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            day: "numeric",
          }).format(item.shareStartTime * 1000);
        endTime =
          new Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
          }).format(item.shareEndTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            month: "numeric",
          }).format(item.shareEndTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            day: "numeric",
          }).format(item.shareEndTime * 1000);

        item["accessStatus"] = `${startTime} ~ ${endTime}`;
      } else {
        startTime = timestampToDate(item.shareStartTime, "DMTY");
        endTime = timestampToDate(item.shareEndTime, "DMTY");

        item["accessStatus"] = `${startTime} to ${endTime}`;
      }
    }

    // item.access = item;
    //returnArr.push(item);

    return item;
  };

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();

      if (item.shareEndTime === 0 && item.shareStartTime === 0) {
        item["accessStatus"] = "All-day Access";
      } else {
        let startTime;
        let endTime;

        if (localizationStrings.getLanguage() === "ja") {
          startTime =
            new Intl.DateTimeFormat("ja-JP", {
              year: "numeric",
            }).format(item.shareStartTime * 1000) +
            new Intl.DateTimeFormat("ja-JP", {
              month: "numeric",
            }).format(item.shareStartTime * 1000) +
            new Intl.DateTimeFormat("ja-JP", {
              day: "numeric",
            }).format(item.shareStartTime * 1000);
          endTime =
            new Intl.DateTimeFormat("ja-JP", {
              year: "numeric",
            }).format(item.shareEndTime * 1000) +
            new Intl.DateTimeFormat("ja-JP", {
              month: "numeric",
            }).format(item.shareEndTime * 1000) +
            new Intl.DateTimeFormat("ja-JP", {
              day: "numeric",
            }).format(item.shareEndTime * 1000);

          item["accessStatus"] = `${startTime} ~ ${endTime}`;
        } else {
          startTime = timestampToDate(item.shareStartTime, "DMTY");
          endTime = timestampToDate(item.shareEndTime, "DMTY");

          item["accessStatus"] = `${startTime} to ${endTime}`;
        }
      }

      item.key = childSnapshot.key;
      item.access = item;
      returnArr.push(item);
    });
    return returnArr;
  };

  handleChange(event) {
    this.setState({
      searchFilter: event.target.value,
    });
  }

  handleCheck(event) {
    fire
      .database()
      .ref("userSettings")
      .child(auth.currentUser.uid)
      .update({
        isBatteryNotificationDisabled: event.target.checked,
      });

    this.setState({
      checkboxChecked: event.target.checked,
    });
  }

  isASharedLock(sharedBy) {
    if (sharedBy === "") {
      return localizationStrings.nonSharedLockTitle;
    } else {
      return sharedBy;
    }
  }

  isOwner(cell, row) {
    if (row.sharedBy === "" && row.ownedBy === auth.currentUser.uid) {
      return true;
    } else {
      return false;
    }
  }

  hasGroupLocks() {
    if (this.state.grouplocklistArray.length < 1) {
      return localizationStrings.noGroupLock;
    } else {
      return localizationStrings.cannotDelete;
    }
  }

  isASharedMode(shareMode) {
    if (shareMode != null && shareMode.includes("RECURR")) {
      if (shareMode === "NORMAL-RECURR") {
        return localizationStrings.recurringNonSharedLockTitle;
      } else if (shareMode === "NORMAL-RECURR-TIMED") {
        return localizationStrings.recurringNonSharedLockTitle;
      } else if (shareMode === "NORMAL-RECURR-LOCKGRP") {
        return localizationStrings.recurringLockGroupLock;
      } else if (shareMode === "NORMAL-RECURR-TIMED-LOCKGRP") {
        return localizationStrings.recurringLockGroupLock;
      } else if (shareMode === "NORMAL-RECURR-GRP") {
        return localizationStrings.recurringUserGroupLock;
      } else if (shareMode === "NORMAL-RECURR-TIMED-GRP") {
        return localizationStrings.recurringUserGroupLock;
      }
    } else if (shareMode != null && shareMode.includes("LOCKGRP")) {
      if (shareMode === "NORMAL-LOCKGRP") {
        return localizationStrings.lockGroupAccess;
      } else if (shareMode === "MULTI-LOCKGRP") {
        return localizationStrings.multiApproveLockGroupLock;
      } else if (shareMode === "MULTI-OTA-LOCKGRP") {
        return localizationStrings.multiApproveOneTimeAccessLockGroupLock;
      } else if (shareMode === "OTA-LOCKGRP") {
        return localizationStrings.oneTimeAccessLockGroupLock;
      }
    } else if (shareMode != null && shareMode.includes("GRP")) {
      if (shareMode === "NORMAL-GRP") {
        return localizationStrings.userGroupAccess;
      } else if (shareMode === "MULTI-GRP") {
        return localizationStrings.multiApproveUserGroupLock;
      } else if (shareMode === "MULTI-OTA-GRP") {
        return localizationStrings.multiApproveOneTimeAccessUserGroupLock;
      } else if (shareMode === "OTA-GRP") {
        return localizationStrings.oneTimeAccessUserGroupLock;
      }
    } else {
      if (shareMode === "" || shareMode === "NORMAL" || shareMode == null) {
        return localizationStrings.nonSharedLockTitle;
      } else if (shareMode === "MULTI") {
        return localizationStrings.multiApproveAccess;
      } else if (shareMode === "MULTI-OTA") {
        return localizationStrings.multiApproveOneTimeAccess;
      } else if (shareMode === "OTA") {
        return localizationStrings.oneTimeAccess;
      }
    }
  }
  isAGroupSharedMode(shareMode) {
    if (
      shareMode != null &&
      (shareMode === "NORMAL-RECURR-GRP" ||
        shareMode === "NORMAL-RECURR-TIMED-GRP")
    ) {
      if (shareMode === "NORMAL-RECURR-GRP") {
        return localizationStrings.recurringNonSharedLockTitle;
      } else if (shareMode === "NORMAL-RECURR-TIMED-GRP") {
        return localizationStrings.recurringNonSharedLockTitle;
      }
    } else {
      if (shareMode === "" || shareMode === "NORMAL-GRP" || shareMode == null) {
        return localizationStrings.nonSharedLockTitle;
      } else if (shareMode === "MULTI-GRP") {
        return localizationStrings.multiApproveAccess;
      } else if (shareMode === "MULTI-OTA-GRP") {
        return localizationStrings.multiApproveOneTimeAccess;
      } else if (shareMode === "OTA-GRP") {
        return localizationStrings.oneTimeAccess;
      }
    }
  }

  tagDetailBtn(cell, row) {
    const lockSerial = row.ip45SerialNumber;
    const lockType = row.Type;
    const lockName = row.Name;

    if (
      row.sharePermissionType == "1" ||
      row.ownedBy === auth.currentUser.uid
    ) {
      return (
        <TagInfoButton
          lockSerial={lockSerial}
          lockType={lockType}
          lockName={lockName}
        >
          Info
        </TagInfoButton>
      );
    } else {
      return "-";
    }
  }
  checklockPass(cell, row) {
    const lockSerial = row.ip45SerialNumber;

    if (row.sharedBy === "" && row.ownedBy === auth.currentUser.uid) {
      return <Login2password lockSerial={lockSerial}>info</Login2password>;
    } else {
      return "-";
    }
  }

  renderDetailsBtn(shareAccessToken) {
    const Locklist = this.state.locklistArray;

    if (shareAccessToken !== "") {
      for (const i in Locklist) {
        if (Locklist[i].shareAccessToken === shareAccessToken) {
          if (
            Locklist[i].sharingMode === "MULTI" ||
            Locklist[i].sharingMode === "MULTI-OTA" ||
            Locklist[i].sharingMode === "MULTI-GRP" ||
            Locklist[i].sharingMode === "MULTI-OTA-GRP" ||
            Locklist[i].sharingMode === "MULTI-LOCKGRP" ||
            Locklist[i].sharingMode === "MULTI-OTA-LOCKGRP"
          ) {
            return <DetailsButton shareAccessToken={shareAccessToken} />;
          } else {
            return "-";
          }
        }
      }
    } else {
      return "-";
    }
  }

  groupRenderDetailsBtn(shareAccessToken) {
    const groupLocklist = this.state.grouplocklistArray;

    if (shareAccessToken !== "") {
      for (const i in groupLocklist) {
        if (groupLocklist[i].shareAccessToken === shareAccessToken) {
          if (
            groupLocklist[i].sharingMode === "MULTI-GRP" ||
            groupLocklist[i].sharingMode === "MULTI-OTA-GRP"
          ) {
            return <DetailsButton shareAccessToken={shareAccessToken} />;
          } else {
            return "-";
          }
        }
      }
    } else {
      return "-";
    }
  }

  renderRecurringSchedule(access) {
    let recurrDays = [];
    let recurrSort = [];
    let recurrSchedule = "";

    if (access.recurringDays === undefined) {
      return "-";
    } else {
      if (_.keys(access.recurringDays).length === 7) {
        return localizationStrings.everyday;
      } else {
        access.recurringDays.forEach((day) => {
          recurrSort.push(day);
        });

        recurrSort.sort((a, b) => a - b);

        recurrSort.forEach((day) => {
          let selectedDay = "";

          switch (day) {
            case 0:
              selectedDay = localizationStrings.recurringDaySun;
              break;
            case 1:
              selectedDay = localizationStrings.recurringDayMon;
              break;
            case 2:
              selectedDay = localizationStrings.recurringDayTue;
              break;
            case 3:
              selectedDay = localizationStrings.recurringDayWed;
              break;
            case 4:
              selectedDay = localizationStrings.recurringDayThu;
              break;
            case 5:
              selectedDay = localizationStrings.recurringDayFri;
              break;
            case 6:
              selectedDay = localizationStrings.recurringDaySat;
              break;
          }

          recurrDays.push(selectedDay);
        });

        for (let i = 0; i < recurrDays.length; i++) {
          if (i === 0) {
            recurrSchedule += recurrDays[i];
          } else {
            recurrSchedule += "," + recurrDays[i];
          }
        }

        return recurrSchedule;
      }
    }
  }

  isPermanentAccessLock(shareStartTime, shareEndTime) {
    if (shareStartTime === 0 || shareEndTime === 0) {
      return "All-day Access";
    } else {
      // var shareStartTime1 = new Date(shareStartTime * 1000).toString();
      // var shareEndTime1 = new Date(shareEndTime * 1000).toString();

      return (
        <div>
          <TimeStamp time={shareStartTime} format="full" includeDay />
          <span>{" to "}</span>
          <TimeStamp time={shareEndTime} format="full" includeDay />
        </div>
      );
    }
  }

  // renderLocklistArray() {
  //   if (!this.state.locklistArray) {
  //     return (
  //       <tr style={center}>
  //         <td colSpan="5">
  //           <NoDataFound />
  //         </td>
  //       </tr>
  //     );
  //   }
  //   if (this.state.loading) {
  //     return (
  //       <tr style={center}>
  //         <td colSpan="5">
  //           <Loading />
  //         </td>
  //       </tr>
  //     );
  //   } else {
  //     return _.map(this.state.locklistArray, (lockData) => {
  //       return (
  //         <tr key={lockData}>
  //           <td>{lockData.Name}</td>
  //           <td>{this.getLockModelName(lockData.Type)}</td>
  //           <td>{lockData.ip45SerialNumber}</td>
  //           <td>{this.isASharedLock(lockData.sharedBy)}</td>
  //           <td>
  //             {this.isPermanentAccessLock(
  //               lockData.shareStartTime,
  //               lockData.shareEndTime
  //             )}
  //           </td>
  //           {/* <td>--edit--</td> */}
  //           {/* <td>--edit--</td> */}
  //         </tr>
  //       );
  //     });
  //   }
  // }

  loadingData() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }
  getUserId = async (email) => {
    const url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/getUserByEmail";

    let userId = "";

    await fetch(url, {
      method: "POST",
      body: JSON.stringify({ email: email }),
    }).then(async (response) => {
      const responseResult = await response.json();
      userId = responseResult.uid;
    });

    return userId;
  };

  saveCellChanges(row, column, newValue) {
    //edit name column
    customLog(row);
    customLog(column);
    customLog(newValue);

    const lockSerial = row.ip45SerialNumber;
    const lockKey = row.key;
    const lockId = row.id;

    // const lockName = row.Name

    // await fire
    //   .database()
    //   .ref("userLocks")
    //   .child(auth.currentUser.uid)
    //   .once("value")
    //   .then(snapshot => {
    //     if (snapshot.exists()) {
    //       snapshot.forEach(lock => {
    //         if (newValue === lock.val().Name && lockName !== lock.val().Name) {
    //           this.setState({
    //             lockNameExist: true
    //           });
    //         }
    //         else {
    //           this.setState({
    //             lockNameExist: false
    //           });
    //         }
    //       });
    //     }
    //   });

    // if (this.state.lockNameExist) {
    //   this.showNotification(
    //     "lock name already exists",
    //     "error",
    //     "tc",
    //     3
    //   );
    // }

    if (newValue.length < 61 && newValue.length !== "") {
      if (newValue !== "") {
        if (row.ownedBy === auth.currentUser.uid) {
          const db = fire.database();
          db.ref("MyAdminLocks")
            .child(auth.currentUser.uid)
            .once("value")
            .then((snapshot) => {
              if (snapshot.exists()) {
                snapshot.forEach((eachLock) => {
                  const eachLockDetails = eachLock.val();
                  const eachAdminLockId = eachLock.key;

                  if (eachLockDetails.ip45SerialNumber === lockSerial) {
                    db.ref("MyAdminLocks")
                      .child(auth.currentUser.uid)
                      .child(eachAdminLockId)
                      .update({
                        lockAlias: newValue,
                      });
                  }
                });
              }
            })
            .then(() => {
              // User Lock Key to get the lock
              //change for everyone
              db.ref(
                "userLocks/" + auth.currentUser.uid + "/" + lockKey,
              ).update({
                Name: newValue,
              });
            })
            .then(() => {
              db.ref("retractableSharingRegistry/" + auth.currentUser.uid)
                .once("value")
                .then((snapshot) => {
                  if (snapshot.exists()) {
                    snapshot.forEach((eachRegistry) => {
                      const eachRegistryVal = eachRegistry.val();
                      if (eachRegistryVal.lockId === lockId) {
                        db.ref(
                          "retractableSharingRegistry/" +
                            auth.currentUser.uid +
                            "/" +
                            eachRegistry.key,
                        ).update({
                          sharedLockName: newValue,
                        });
                      }
                    });
                  }
                });
            })
            .then(() => {
              db.ref(
                "GroupManagement/" +
                  this.state.superAdminID +
                  "/" +
                  auth.currentUser.uid,
              )
                .once("value")
                .then((snapshot) => {
                  if (snapshot.exists()) {
                    snapshot.forEach((eachGroup) => {
                      const eachGroupLocks = eachGroup.val().groupLocks;

                      for (let eachLockId in eachGroupLocks) {
                        const eachLockDetails = eachGroupLocks[eachLockId];

                        if (eachLockDetails.id === lockId) {
                          // console.log(eachGroup.key);
                          // console.log(eachLockDetails.id);
                          db.ref(
                            "GroupManagement/" +
                              this.state.superAdminID +
                              "/" +
                              auth.currentUser.uid +
                              "/" +
                              eachGroup.key +
                              "/groupLocks/" +
                              eachLockDetails.snapID,
                          ).update({
                            Name: newValue,
                          });
                        }
                      }
                    });
                  }
                });
            })
            .then(() => {
              db.ref("groupAccounts")
                .child(this.state.superAdminID)
                .child("members")
                .once("value")
                .then((snapshots) => {
                  snapshots.forEach((snap) => {
                    this.getUserId(snap.val().memberEmail).then((userId) => {
                      // Get all userLocks with same lock id
                      db.ref("retractableSharingRegistry")
                        .child(userId)
                        .orderByChild("lockId")
                        .equalTo(row.id)
                        .once("value")
                        .then((snapshot) => {
                          if (snapshot.exists()) {
                            // Update name of all locks
                            snapshot.forEach((snap) => {
                              let key = snap.key;
                              // console.log(snap.key)
                              db.ref("retractableSharingRegistry")
                                .child(userId)
                                .child(key)
                                .update({
                                  sharedLockName: newValue,
                                });
                            });
                          }
                        });

                      // Get all userLocks with same lock id

                      db.ref("userLocks")
                        .child(userId)
                        .orderByChild("id")
                        .equalTo(row.id)
                        .once("value")
                        .then((snapshot) => {
                          if (snapshot.exists()) {
                            // Update name of all locks
                            snapshot.forEach((snap) => {
                              let key = snap.key;

                              db.ref("userLocks")
                                .child(userId)
                                .child(key)
                                .update({
                                  Name: newValue,
                                });
                            });
                          }
                        });
                    });
                  });
                });
            });
          this.showNotification(
            localizationStrings.lockNameChangeSuccess,
            "success",
            "tc",
            3,
          );
        }
      } else {
        this.showNotification(
          localizationStrings.lockNameEmpty,
          "error",
          "tc",
          3,
        );

        this.reloadLocklist();
        this.groupreloadLocklist();
      }
    } else {
      this.showNotification(localizationStrings.lockNameLong, "error", "tc", 3);

      this.reloadLocklist();
      this.groupreloadLocklist();
    }
    // if (column === "name") {
    //   if (newValue.length < 31 && newValue.length !== "") {
    //     const db = fire.database();
    //     db.ref("userLocks")
    //       .child(auth.currentUser.uid)
    //       .child(row.key)
    //       .update({
    //         Name: newValue
    //       });

    //     db.ref("retractableSharingRegistry/" + auth.currentUser.uid)
    //       .once("value")
    //       .then(snapshot => {
    //         snapshot.forEach(eachLock => {
    //           const eachLockDetails = eachLock.val();
    //           if (eachLockDetails.sharedLockName === row.nameKey) {
    //             const lockId = eachLockDetails.id;
    //             db.ref(
    //               "retractableSharingRegistry/" +
    //                 auth.currentUser.uid +
    //                 "/" +
    //                 lockId
    //             ).update({
    //               sharedLockName: newValue
    //             });
    //           }
    //         });
    //       });

    //     //TODO: -> RE-RENDER JUST THIS COMPONENT HERE
    //     // window.location.reload();
    //     row.name = newValue;
    //   } else {
    //     row.name = row.nameKey;
    //     // alert("Sorry, your input is invalid!")
    //     const errMsg = "Sorry, your input is invalid!";
    //     this.showNotification(errMsg, "error", "tc", 3);
    //   }
    // }
    // //edit remark column
    // if (column === "remark") {
    //   if (newValue.length < 31) {
    //     fire
    //       .database()
    //       .ref("userLocks")
    //       .child(auth.currentUser.uid)
    //       .child(row.key)
    //       .update({
    //         remark: newValue
    //       });

    //     // window.location.reload();
    //   } else {
    //     // alert("Sorry, maximum of 30 characters only!")
    //     const errMsg = "Sorry, maximum of 30 characters only!";
    //     this.showNotification(errMsg, "error", "tc", 3);
    //   }
    // }
  }

  // handleDeleteButtonClick(){

  //     // Firebase Delete
  //     // customLog(myArr)
  //     //look up the data
  //     // var db+ //Eg key is employee id
  //     myArr.forEach((i) => {
  //       // customLog(i)
  //       fire.database().ref('userLocks').child(auth.currentUser.uid).child(i).remove().then(() => {
  //         // window.location.reload();
  //       })
  //     })

  //     // fire.database().ref("userLocks").child(auth.currentUser.uid).child("").remove()
  //     // .then(() =>{

  //     //     window.location.reload();
  //     // });
  // }
  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="searchBar"
        accessStatus
        // id="retractSearch"
        placeholder={localizationStrings.searchPlaceholder}
        style={{ marginTop: "15px" }}
      />
    );
  };

  createCustomDeleteButton = (onClick) => {
    return (
      <Button
        bsSize="large"
        id="retractableBtn"
        style={{ width: "100%", marginTop: "10px" }}
        onClick={onClick}
      >
        <i className="far fa-trash-alt" /> {localizationStrings.removeSelected}
      </Button>
    );
  };

  renderDeleteBtn() {
    return (
      <Button
        // style={deletebtnStyle}
        variant="primary"
        id="locklistDeleteBtn"
        onClick={
          // customLog(myArr)
          this.confirmDelete
        }
      >
        DELETE
      </Button>
    );
  } // end of renderDeleteBtn

  onToggleDropDown = (toggleDropDown) => {
    // do your stuff here
    // console.log(toggleDropDown)
    // console.log('toggle dropdown');
    toggleDropDown();
  };

  renderSizePerPageDropDown = (props) => {
    const handleClick = (event) => {
      event.preventDefault();
      this.onToggleDropDown(props.toggleDropDown);
    };

    return (
      <SizePerPageDropDown
        variation="dropup"
        onClick={handleClick}
        {...props}
      ></SizePerPageDropDown>
    );
  };

  saveActivityLogs() {
    let activityLogsDB = fire
      .database()
      .ref("activityLogs")
      .child(auth.currentUser.uid);
    let key = activityLogsDB.push().key;

    // Role is already known from login — no groupAccounts scan needed
    const logEntry = {
      Type: 0,
      description: "Removed a registered lock.",
      email: auth.currentUser.email,
      time: Math.floor(new Date() / 1000),
      userUID: auth.currentUser.uid,
      device: "",
    };

    fire
      .database()
      .ref("activityLogs")
      .child(auth.currentUser.uid)
      .child(key)
      .set(logEntry);
  }
  createCustomExportCSVButton = (onClick) => {
    return (
      <ExportCSVButton
        btnText={localizationStrings.exportCSVTitle}
        className="exportCSVBtn"
        onClick={
          () => this.handleExportCSVButtonClick(onClick)
          // this.testcsv(onclick)
        }
      />
    );
  };
  handleExportCSVButtonClick = (onClick) => {
    this.setState({
      showExportPopup: true,
      //showLowBatteryPopup: true
      // showPopup:true
    });
  };
  async handleExportCSV() {
    //make it work with jp
    var data = [];
    // console.log(this.state.locklistArray)
    for (var i = 0; i < this.state.locklistArray.length; i++) {
      var lock = this.state.locklistArray[i];
      data.push({
        [localizationStrings.headerName]: lock.Name,
        [localizationStrings.headerSerial]: lock.ip45SerialNumber,
        [localizationStrings.headerModel]: this.getLockModelName(lock.Type),
        [localizationStrings.headerShareBy]: this.isASharedLock(lock.sharedBy),
        [localizationStrings.headerShareMode]: this.isASharedMode(
          lock.sharingMode,
        ),
        [localizationStrings.headerShareTimed]: lock.accessStatus,
      });
      //console.log(data)
    }
    const options = {
      filename: auth.currentUser.email + "locks",
      showTitle: true,
      title: auth.currentUser.email + " locks",
      useTextFile: false,
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      useBom: true,
      headers: [
        localizationStrings.headerName,
        localizationStrings.headerSerial,
        localizationStrings.headerModel,
        localizationStrings.headerShareBy,
        localizationStrings.headerShareMode,
        localizationStrings.headerShareTimed,
      ],
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(data);
    this.setState({
      showExportPopup: false,
    });
  }

  deleteLock(rowKeys) {
    let activityLogsDB = fire
      .database()
      .ref("individualActivities")
      .child(auth.currentUser.uid);
    let activityKey = activityLogsDB.push().key;
    const deletelockName = [];
    const deletelockAlias = [];
    const deletelockSerial = [];
    const deletelockFromAdmin = [];
    let deleteNam = "";
    let deleteSer = "";
    let deleteAdmLock = "";

    // let notificationsDB = fire.database().ref("individualNotifications").child(auth.currentUser.uid);
    // let notificationsKey = notificationsDB.push().key;
    customLog("deleteLock function running");
    customLog(rowKeys);
    const db = fire.database();
    rowKeys.forEach(async (i) => {
      customLog(i);

      await db
        .ref("userLocks/" + auth.currentUser.uid + "/" + i)
        .once("value")
        .then((snapshot2) => {
          const snapshotval = snapshot2.val();
          deletelockName.push(snapshotval.Name);
          deletelockSerial.push(snapshotval.ip45SerialNumber);
          deletelockFromAdmin.push(snapshotval.fromAdmin);
          deleteNam = snapshotval.Name;
          deleteSer = snapshotval.ip45SerialNumber;
          deleteAdmLock = snapshotval.fromAdmin;
        });

      await db
        .ref("MyAdminLocks/" + auth.currentUser.uid)
        .orderByChild("ip45SerialNumber")
        .equalTo(deleteSer)
        .once("value", function(snapshot) {
          snapshot.forEach(function(childSnapshot) {
            // Retrieve the key associated with the lock data
            var lockKey = childSnapshot.key;

            customLog("MyAdminLocks iddele key: " + lockKey);

            // Now you can remove the lock using the retrieved key
            db.ref("MyAdminLocks/" + auth.currentUser.uid + "/" + lockKey)
              .remove()
              .then(function() {
                customLog("Lock removed successfully");
              })
              .catch(function(error) {
                customLog("Error removing lock: ", error);
              });
            // });
          });
        });

      //remove admin lock
      if (!this.state.isSuperAdmin) {
        customLog("here is super admin lock deletion");
        await db
          .ref("MyAdminLocks/" + this.state.superAdminID)
          .orderByChild("ip45SerialNumber")
          .equalTo(deleteSer)
          .once("value", (snapshot) => {
            snapshot.forEach((childSnapshot) => {
              // Retrieve the key associated with the lock data
              var lockKey = childSnapshot.key;

              customLog("MyAdminLocks iddele key: " + lockKey);

              // Now you can remove the lock using the retrieved key
              db.ref("MyAdminLocks/" + this.state.superAdminID + "/" + lockKey)
                .remove()
                .then(function() {
                  customLog("Lock removed successfully");
                })
                .catch(function(error) {
                  customLog("Error removing super admin lock: ", error);
                });
              // });
            });
          });

        await db
          .ref("userLocks/" + this.state.superAdminID + "/" + i)
          .remove()
          .then(
            customLog(
              "Success removing super admin lock: ",
              this.state.superAdminID,
            ),
          );
      } else {
        customLog("here is admin lock deletion");
        await db
          .ref("MyAdminLocks/" + deleteAdmLock)
          .orderByChild("ip45SerialNumber")
          .equalTo(deleteSer)
          .once("value", function(snapshot) {
            snapshot.forEach(function(childSnapshot) {
              // Retrieve the key associated with the lock data
              var lockKey = childSnapshot.key;

              customLog("MyAdminLocks iddele key: " + lockKey);

              // Now you can remove the lock using the retrieved key
              db.ref("MyAdminLocks/" + deleteAdmLock + "/" + lockKey)
                .remove()
                .then(function() {
                  customLog("Lock removed successfully");
                })
                .catch(function(error) {
                  customLog("Error removing admin lock: ", error);
                });
              // });
            });
          });

        await db
          .ref("userLocks/" + deleteAdmLock + "/" + i)
          .remove()
          .then(customLog("Success removing admin lock: ", deleteAdmLock));
      }

      // update activity
      await db
        .ref("userLocks/" + auth.currentUser.uid + "/" + i)
        .remove()
        .then(
          // console.log("Hello checking the remove()");

          this.updateActivities(deleteNam, deleteSer, activityLogsDB),
        );

      // 🔹 Delete from lockGroupManagement
      const groupRootRef = db.ref(
        "lockGroupManagement/" + this.state.superAdminID,
      );
      const ownersSnap = await groupRootRef.once("value");

      if (ownersSnap.exists()) {
        for (const [ownerUID, groups] of Object.entries(ownersSnap.val())) {
          for (const [groupHash, groupData] of Object.entries(groups)) {
            if (groupData.locks) {
              for (const [lockKey, serial] of Object.entries(groupData.locks)) {
                if (serial === deleteSer) {
                  await db
                    .ref(
                      `lockGroupManagement/${this.state.superAdminID}/${ownerUID}/${groupHash}/locks/${lockKey}`,
                    )
                    .remove();

                  customLog(
                    `🗑️ Deleted lock ${deleteSer} (key: ${lockKey}) from group ${groupHash} (owner: ${ownerUID})`,
                  );
                }
              }
            }
          }
        }
      }

      await db
        .ref("retractableSharingRegistry/" + auth.currentUser.uid)
        .once("value")
        .then(async (snapshot) => {
          if (snapshot.exists()) {
            customLog("Lock id does exist 1 !!!!!!!!! i : " + i);

            const entries = [];

            snapshot.forEach((childSnapshot) => {
              entries.push({ key: childSnapshot.key, ...childSnapshot.val() });
            });
            // console.log("entries ", entries);

            for (const data of entries) {
              if (data.lockId === i) {
                let language = "";
                // Fetch user's language
                const settingSnapshot = await fire
                  .database()
                  .ref("userSettings")
                  .child(auth.currentUser.uid)
                  .once("value");
                language = settingSnapshot.val().language;
                customLog("Language " + language);

                customLog("lock id " + i.toString());
                customLog(
                  "retractableSharingRegistryid " + data.key.toString(),
                );

                fire
                  .database()
                  .ref("retractableSharingRegistry")
                  .child(auth.currentUser.uid)
                  .child(data.key)
                  .remove()
                  .then(async () => {
                    customLog("✅ Successfully removed: " + data.key);
                    // Next steps here...
                    // Delete from registry using shareAccessToken
                    const shareToken = data.shareAccessToken;
                    const shareToUid = data.sharedToUID;
                    const shareToEmail = data.sharedToEmail;
                    const lockSerial = data.lockSerial;
                    customLog("shareToken " + shareToken);

                    const isGroup =
                      data.sharingMode === "NORMAL-GRP" ||
                      data.sharingMode === "OTA-GRP" ||
                      data.sharingMode === "MULTI-GRP" ||
                      data.sharingMode === "MULTI-OTA-GRP";

                    const fetchUrl =
                      "https://us-central1-egeetouchindustrial.cloudfunctions.net/retractAccessEmail";

                    if (isGroup) {
                      customLog("isgroudp");

                      let superAdminID;

                      const groupSnapshot = await fire
                        .database()
                        .ref("groupAccounts")
                        .once("value");
                      if (groupSnapshot.exists()) {
                        groupSnapshot.forEach((superAdmin) => {
                          const superAdminData = superAdmin.val();
                          const memberDetails = superAdminData.members;

                          for (let eachMemberId in memberDetails) {
                            const eachMemberDetails =
                              memberDetails[eachMemberId];
                            const eachMemberEmail =
                              eachMemberDetails.memberEmail;

                            if (eachMemberEmail === auth.currentUser.email) {
                              superAdminID = superAdmin.key;
                            }
                          }
                        });
                      }

                      const groupManagementSnapshot = await fire
                        .database()
                        .ref("GroupManagement")
                        .child(superAdminID)
                        .child(auth.currentUser.uid)
                        .child(shareToUid)
                        .child("groupMembers")
                        .once("value");

                      if (groupManagementSnapshot.exists()) {
                        groupManagementSnapshot.forEach((groupMember) => {
                          const groupMemberData = groupMember.val();
                          const emailOfSharedUser = groupMemberData.memberEmail;

                          const dataToSend = {
                            lockSerial: lockSerial,
                            email: emailOfSharedUser,
                            ownerUid: auth.currentUser.uid,
                            language: language,
                          };

                          fetch(fetchUrl, {
                            method: "POST",
                            body: JSON.stringify(dataToSend),
                          });
                        });
                      }

                      await fire
                        .database()
                        .ref("GroupManagement")
                        .child(superAdminID)
                        .child(auth.currentUser.uid)
                        .child(shareToUid)
                        .child("groupLocks")
                        .child(data.key)
                        .remove();
                    } else {
                      customLog("not group");

                      const dataToSend = {
                        lockSerial: lockSerial,
                        email: shareToEmail,
                        ownerUid: auth.currentUser.uid,
                        language: language,
                      };

                      customLog("dataToSend", dataToSend);
                      fetch(fetchUrl, {
                        method: "POST",
                        body: JSON.stringify(dataToSend),
                      });

                      const shareRef = fire.database().ref();
                      const toDelete = [];
                      const emailToUidCache = {}; // email -> UID
                      const retractableCache = {}; // UID -> retractableSharingRegistry data

                      // Step 1: Fetch all userLocks for the shareToUid
                      const userLocksSnap = await shareRef
                        .child("userLocks")
                        .child(shareToUid)
                        .once("value");
                      const userLocks = userLocksSnap.val() || {};

                      // Step 2: Fetch registeredUsersOnPlatform once and invert it to {email: uid}
                      const usersSnap = await shareRef
                        .child("registeredUsersOnPlatform")
                        .once("value");
                      const uidToEmailMap = usersSnap.val() || {};
                      Object.entries(uidToEmailMap).forEach(([uid, email]) => {
                        emailToUidCache[email] = uid;
                      });

                      // Step 3: Loop over userLocks and decide which to delete
                      for (const [lockId, lockData] of Object.entries(
                        userLocks,
                      )) {
                        const shareAccessToken = lockData?.shareAccessToken;

                        if (!shareAccessToken) {
                          customLog(
                            `❌ [SKIPPED] ${lockId} — no shareAccessToken`,
                          );
                          continue;
                        }

                        if (shareAccessToken === shareToken) {
                          customLog(`🗑️ [DELETE] ${lockId} — token matches`);
                          toDelete.push(lockId);
                          continue;
                        }

                        // shareAccessToken !== shareToken → check retractable registry
                        const sharedByEmail = lockData?.sharedBy;

                        if (!sharedByEmail) {
                          customLog(
                            `❌ [SKIPPED] ${lockId} — no sharedBy email`,
                          );
                          continue;
                        }

                        const sharedByUid = emailToUidCache[sharedByEmail];

                        if (!sharedByUid) {
                          customLog(
                            `❌ [SKIPPED] ${lockId} — UID not found for email: ${sharedByEmail}`,
                          );
                          continue;
                        }

                        // Load retractableSharingRegistry/{sharedByUid} if not cached
                        if (!retractableCache[sharedByUid]) {
                          const retractableSnap = await shareRef
                            .child("retractableSharingRegistry")
                            .child(sharedByUid)
                            .once("value");

                          retractableCache[sharedByUid] =
                            retractableSnap.val() || {};
                          customLog(
                            `📚 Loaded retractableSharingRegistry for ${sharedByUid}:`,
                            retractableCache[sharedByUid],
                          );
                        }

                        let foundMatch = false;
                        // Check each shareAccessToken in retractableSharingRegistry for matching shareAccessToken
                        for (const [hash, entry] of Object.entries(
                          retractableCache[sharedByUid],
                        )) {
                          if (entry.shareAccessToken === shareAccessToken) {
                            customLog(
                              `✅ [KEEP] ${lockId} — token matches in retractableSharingRegistry`,
                            );
                            foundMatch = true;
                            break;
                          }
                        }

                        if (!foundMatch) {
                          customLog(
                            `🗑️ [DELETE] ${lockId} — no matching shareAccessToken found in registry`,
                          );
                          toDelete.push(lockId);
                        }
                      }

                      // Step 4: Perform batch deletion
                      if (toDelete.length > 0) {
                        const updates = {};
                        toDelete.forEach((lockId) => {
                          updates[`userLocks/${shareToUid}/${lockId}`] = null;
                        });

                        await shareRef.update(updates);
                        customLog(`🔥 Deleted ${toDelete.length} lock(s)`);
                      } else {
                        customLog("✅ No locks to delete.");
                      }
                    }
                  })
                  .catch((err) => {
                    console.error("Firebase remove error:", err);
                  });
              }
            }
          } else {
            customLog("Lock id doesn't exist 1 --------");
          }
        })
        .then(() => {
          this.saveActivityLogs();
          this.showNotification(
            localizationStrings.lockDeleted,
            "success",
            "tc",
            5,
          );
          //  if (deletelockName.length>1 && deletelockSerial.length>1){
          //     for(let index=0;index < deletelockName.length; index++)
          //  {
          deletelockName.forEach((deletedlockName) => {});
          let activityKey = activityLogsDB.push().key;
        });
    });
  }

  confirmDelete = (next, dropRowKeys) => {
    confirmAlert({
      title: `${localizationStrings.confirmRetractTitle} (${dropRowKeys.length})`,
      message: this.buildDeletePreview(dropRowKeys),
      buttons: [
        {
          label: localizationStrings.confirmRetractButton,
          onClick: () => next(),
        },
        {
          label: localizationStrings.cancelRetractButton,
          onClick: () => false,
        },
      ],
    });
  };

  buildDeletePreview = (dropRowKeys = []) => {
    const selectedLocks = this.state.locklistArray.filter((lock) =>
      dropRowKeys.includes(lock.key),
    );

    const total = selectedLocks.length;

    if (total === 0) {
      return localizationStrings.confirmRetractMessage;
    }

    const lockLines = selectedLocks.slice(0, 5).map((lock, index) => {
      const name = lock.Name || "-";
      const serial = lock.ip45SerialNumber || "-";

      return `${index + 1}. ${name} (${serial})`;
    });

    if (total > 5) {
      return (
        <div>
          <p>
            You are about to remove <strong>{total}</strong> selected locks.
          </p>
          <div style={{ marginTop: "10px", marginBottom: "10px" }}>
            {lockLines.map((line, index) => (
              <div key={index}>{line}</div>
            ))}
            <div style={{ marginTop: "8px", fontStyle: "italic" }}>
              ...and {total - 5} more selected lock{total - 5 > 1 ? "s" : ""}.
            </div>
          </div>
          <p>{localizationStrings.confirmRetractMessage}</p>
        </div>
      );
    }

    return (
      <div>
        <p>
          You are about to remove <strong>{total}</strong> selected lock
          {total > 1 ? "s" : ""}.
        </p>
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          {lockLines.map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
        <p>{localizationStrings.confirmRetractMessage}</p>
      </div>
    );
  };

  handlePopupOpen() {
    this.setState({
      // showPopup: true,
      // popupTitle: localizationStrings.registerLockGuide,
      // popupImage: [<RegisterLock />],
      showExportPopup: true,
    });
  }

  handlePopupClose() {
    this.setState({ showExportPopup: false });
  }
  handleHelpPopupOpen() {
    this.setState({
      showHelpPopup: true,
      popupTitle: localizationStrings.registerLockGuide,
      popupImage: [<RegisterLock />],
    });
  }

  handleHelpPopupClose() {
    this.setState({ showHelpPopup: false });
  }

  handleLowBatteryPopupOpen() {
    this.setState({ showLowBatteryPopup: true });
  }

  handleLowBatteryPopupClose() {
    this.setState({
      showLowBatteryPopup: false,
    });
  }

  updateActivities(name, serial, DB) {
    let activityKey = DB.push().key;

    // console.log("swagg "+deletelockName[index])
    //   console.log("swagg2 "+deletelockName[0])
    // }
    // }
    // else{
    fire
      .database()
      .ref("individualActivities")
      .child(auth.currentUser.uid)
      .child(activityKey)
      .update({
        activityType: 5,
        description: name + "(" + serial + ") ",
        detailedDescription: "",
        // isRead: false,
        platform: "Web App",
        userUID: auth.currentUser.uid,
        userEmail: auth.currentUser.email,
        snapKey: activityKey,
        timeStamp: Math.floor(new Date()),
      });
  }
  // collectBatteryData(serialNumber) {
  //   var batteryLevels = 0
  //   if (serialNumber) {
  //     fire
  //       .database()
  //       .ref("lockHardwareStatus")
  //       .child(serialNumber)
  //       .once("value")
  //       .then((snapshot) => {
  //         // console.log(snapshot.val().batteryLevel)
  //         console.log(serialNumber)
  //         return "hello" + serialNumber
  //         // if (snapshot.exists()) {
  //         //   var batteryLevel = snapshot.val().batteryLevel
  //         //   var batteryWithPercent = batteryLevel + "%";
  //         //   console.log(batteryWithPercent)
  //         //   return batteryWithPercent;
  //         // }
  //         // return snapshot.val().batteryLevel
  //         batteryLevels = snapshot.val().batteryLevel
  //       })

  //     // console.log(batteryLevels)
  //   } else {
  //     return "NO"
  //   }
  //   console.log(batteryLevels)
  // }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    //! for data
    // const lockListData = _.map(this.state.locklistArray, (lLData) => {
    //   // customLog(atData);
    //   return {
    //     Name: lLData.Name,
    //     ip45SerialNumber: lLData.ip45SerialNumber,
    //     Type: lLData.Type,
    //     sharedBy: lLData.shareBy,
    //     accessStatus: lLData.accessStatus,
    //     batteryLevel: this.collectBatteryData(lLData.ip45SerialNumber),
    //   };
    // });

    function japaneseFormat(cell, row) {
      if (
        cell === "All-day Access"
        // && localizationStrings.getLanguage() === "ja"
      )
        return localizationStrings.fullAccessTitle;
      else return cell;
    }

    function batteryFormat(cell, row) {
      if (cell === "-") {
        return <div style={{ color: "grey" }}>{cell + "-"}</div>;
      } else if (cell < 50) {
        return <div style={{ color: "red" }}>{cell + "%"}</div>;
      } else {
        return <div style={{ color: "green" }}>{cell + "%"}</div>;
      }
    }
    // const { SearchBar } = Search;

    const cellEditProp = {
      mode: "dbclick",
      blurToSave: true,
      afterSaveCell: this.saveCellChanges,
    };

    /* const thArray = [
      {
        dataField: "key",
        text: "key",
        hidden: true,
      },
      {
        dataField: "nameKey",
        text: localizationStrings.headerName,
        sort: true,
        hidden: true,
      },

      {
        dataField: "name",
        text: localizationStrings.headerName,
        sort: true,
        edtiable: true,
      },
      {
        dataField: "serial",
        text: localizationStrings.headerSerial,
        sort: true,
        editable: false,
      },
      {
        dataField: "model",
        text: localizationStrings.headerModel,
        editable: false,
        sort: true,
      },
      {
        dataField: "share",
        text: localizationStrings.headerShare,
        editable: false,
        sort: true,
      },
      {
        dataField: "access",
        text: localizationStrings.headerAccess,
        editable: false,
      },
      // , {
      //   dataField: 'address',
      //   text: 'Address(ロク一ション (住所))',
      //   editable: false
      // }, {
      //   dataField: 'remark',
      //   text: 'Remark(リマーク)',
      // }
    ];

    const lockListData = _.map(this.state.locklistArray, (lockData) => {
      return {
        key: lockData.key,
        nameKey: lockData.Name,
        name: lockData.Name,
        serial: lockData.ip45SerialNumber,
        model: this.getLockModelName(lockData.Type),
        share: this.isASharedLock(lockData.sharedBy),
        access: this.isPermanentAccessLock(
          lockData.shareStartTime,
          lockData.shareEndTime
        ),
        address: "-edit-",
        remark: "-edit-",
      };
    }); */

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "right" }}
      >
        {localizationStrings.resultTitle1}
        {from}
        {localizationStrings.resultTitle2}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );
    const logsListData = this.state.locklistArray;
    const logsListData2 = this.state.locklistArray.filter(
      (lock) => lock.batteryLevel <= 15,
    );

    const options = {
      paginationSize: 10,
      pageStartIndex: 1,
      // alwaysShowAllBtns: true, // Always show next and previous button
      // withFirstAndLast: false, // Hide the going to First and Last page button
      // hideSizePerPage: true, // Hide the sizePerPage dropdown always
      // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      afterDeleteRow: this.deleteLock,
      handleConfirmDeleteRow: this.confirmDelete,
      deleteBtn: this.createCustomDeleteButton,

      firstPageText: "<<",
      prePageText: "<",
      nextPageText: ">",
      lastPageText: ">>",
      nextPageTitle: localizationStrings.nextPage,
      prePageTitle: localizationStrings.prePage,
      firstPageTitle: localizationStrings.firstPage,
      lastPageTitle: localizationStrings.lastPage,
      showTotal: true,
      paginationShowsTotal: customTotal,
      // noDataText: this.loadingData,
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: logsListData.length,
          //   value: this.state.grouplocklistArray.length
        },
      ], // A numeric array is also available. the purpose of above example is custom the text
      searchField: this.createCustomSearchField,
      // deleteBtn: this.createCustomDeleteButton
      // noDataText: localizationStrings.noDataTitle,
      noDataText: this.loadingData(),
      exportCSVBtn: this.createCustomExportCSVButton,
    };
    const options2 = {
      paginationSize: 10,
      pageStartIndex: 1,
      afterDeleteRow: this.deleteLock,
      handleConfirmDeleteRow: this.confirmDelete,
      deleteBtn: this.createCustomDeleteButton,
      exportCSVBtn: this.createCustomExportCSVButton,
      firstPageText: "<<",
      prePageText: "<",
      nextPageText: ">",
      lastPageText: ">>",
      nextPageTitle: localizationStrings.nextPage,
      prePageTitle: localizationStrings.prePage,
      firstPageTitle: localizationStrings.firstPage,
      lastPageTitle: localizationStrings.lastPage,
      showTotal: true,
      paginationShowsTotal: customTotal,
      sizePerPageDropDown: this.renderSizePerPageDropDown,
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: logsListData2.length,
          //   value: this.state.grouplocklistArray.length // ? Should this be a separate sizePerPage option?
        },
      ],
      searchField: this.createCustomSearchField,
      noDataText: localizationStrings.noDataTitle,
    };

    const selectRow = {
      bgColor: "#eeeeee",
      mode: "checkbox",
      selected: this.state.selectedLocks,
      unselectable: this.state.locklistArray
        .filter(
          (row) =>
            row.sharingMode &&
            row.sharingMode.includes("GRP") &&
            !row.sharingMode.includes("LOCKGRP"),
        )
        .map((row) => row.key),
      onSelect: (row, isSelected) => {
        const { selectedLocks } = this.state;

        const updatedSelectedRows = isSelected
          ? [...selectedLocks, row.key]
          : selectedLocks.filter((key) => key !== row.key);

        this.setState({ selectedLocks: updatedSelectedRows });
      },
      onSelectAll: (isSelected) => {
        const updatedSelectedRows = isSelected
          ? this.state.locklistArray
              .filter(
                (row) =>
                  !(
                    row.sharingMode &&
                    row.sharingMode.includes("GRP") &&
                    !row.sharingMode.includes("LOCKGRP")
                  ),
              )
              .map((row) => row.key)
          : [];

        this.setState({ selectedLocks: updatedSelectedRows });
      },
    };

    // const selectRow = {
    //   bgColor: "#eeeeee",
    //   mode: "checkbox"

    // clickToSelect: true,
    // clickToEdit: true,
    // hideSelectAll: true,
    // onSelect: (row, isSelect, rowIndex, e) => {
    //   // customLog(`row: ${row.key} isSelect ${isSelect} rowIndex ${rowIndex} e ${e}`)

    //   if (isSelect) {
    //     myArr.push(row.key);
    //   } else {
    //     for (var i = myArr.length - 1; i >= 0; i--) {
    //       if (myArr[i] === row.key) {
    //         myArr.splice(i, 1);
    //         // break;       //<-- Uncomment  if only the first term has to be removed
    //       } //end of if(myArr[i] === row.key)
    //     }
    //   } //end of if(isSelected)

    //   if (myArr.length > 0) {
    //     this.setState({ isDeleteMode: true });
    //   } else {
    //     this.setState({ isDeleteMode: false });
    //   }

    //   // customLog(this.state.selectedLockKeysArray)p
    //   // customLog(myArr.length)
    // } //end of onSelected
    // };

    const groupselectRow = {
      bgColor: "#eeeeee",
      mode: "checkbox",

      // checkboxEnabled:false,
      // checkboxChecked:false,
      // Checkbox:false,
      // onClick:false,
      // clickToSelect:true,
      // checked:DISABLED

      // clickToSelect: true,
      // clickToEdit: true,
      // hideSelectAll: true,
    };

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };

    return (
      <div
        style={{
          maxWidth: "95%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <NotificationSystem ref="notificationSystem" style={style} />
        <div
          style={{ display: this.state.lowBatteryDetected ? "block" : "none" }}
        >
          <div className="lowBatteryNotification">
            <p>{localizationStrings.lowBatteryLocksDetected}</p>
            <p>
              <u>
                <a
                  style={{ color: "white" }}
                  href="#"
                  onClick={this.handleLowBatteryPopupOpen}
                >
                  {localizationStrings.viewLocks}
                </a>
              </u>
            </p>
          </div>
        </div>
        {/* {props => ( */}
        {/* maxWidth: "95%", */}
        <div style={{ margin: "auto" }} className="header">
          <div className="helpDiv">
            <h2 className={"lockListHeader"}>
              {localizationStrings.locklistTitle}
            </h2>
            <button className="helpButton" onClick={this.handleHelpPopupOpen}>
              <i
                class="fa fa-question-circle"
                style={{ marginLeft: "10px" }}
              ></i>
              <p style={{ fontSize: "28px", margin: "0 10px 0 20px" }}>
                {localizationStrings.helpButtonLabel}
              </p>
            </button>
          </div>
          <div>
            {/* <h4>{localizationStrings.descriptionTitle}</h4> */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "-24px",
              }}
            >
              <h6
                style={{
                  margin: "30px 0px 15px",
                  lineHeight: "30px",
                  padding: "2px",
                }}
              >
                {localizationStrings.descriptionSubtitle1}
              </h6>
              <button
                className="helpButtonMini"
                onClick={this.handleHelpPopupOpen}
                disabled
              >
                <i
                  class="fa fa-question-circle"
                  style={{ fontSize: "20px", marginLeft: "3px" }}
                ></i>
                <p style={{ fontSize: "17px", margin: "0 3px 0 5px" }}>
                  {localizationStrings.helpButtonLabel}
                </p>
              </button>
              <h6
                style={{
                  margin: "30px 0px 15px",
                  lineHeight: "30px",
                  padding: "2px",
                }}
              >
                {localizationStrings.descriptionSubtitle2}
              </h6>
            </div>
            {/* <h6
              style={{
                margin: "-10px 0px 15px",
                lineHeight: "30px",
                padding: "2px"
              }}
            >
              {localizationStrings.cannotRemove}
            </h6> */}
            <h6 className="instructionStyle">
              {localizationStrings.doubleClickInstruc}
            </h6>
          </div>
          <br />
        </div>

        <Tabs defaultIndex={0} onSelect={this.handleTabs}>
          <TabList>
            <Tab>{localizationStrings.individualTab}</Tab>
            {this.state.isSuperAdmin && (
              <Tab>{localizationStrings.groupTab}</Tab>
            )}
          </TabList>
          {/* individual */}
          <TabPanel>
            <div style={{ marginTop: "20px" }}>
              <BootstrapTable
                id="table"
                pagination={true}
                search
                bordered={false}
                data={this.state.locklistArray}
                exportCSV
                // columns={thArray}
                selectRow={selectRow}
                deleteRow
                options={options}
                loading={this.state.loading}
                cellEdit={cellEditProp}
                className="shareModeWordWrap timedAccessWordWrap shareByEllipsis horizontalScrollFade stickyColumn"
                tableStyle={{
                  overflowX: "scroll",
                  tableLayout: "auto",
                  width: "100%",
                  display: "block",
                }}
                // tableStyle={{ display: "block", width: "100%", overflowX: "auto", whiteSpace: "nowrap" }}
              >
                <TableHeaderColumn
                  dataSort
                  dataField="key"
                  isKey={true}
                  hidden
                />
                <TableHeaderColumn
                  dataSort
                  dataField="Name"
                  editable={this.isOwner}
                  columnTitle={columnHover}
                  thStyle={{ width: "190px" }}
                  tdStyle={{ width: "190px", height: "80px" }}
                  // thStyle={{ position: "absolute" }}
                  // tdStyle={{ position: "absolute" }}
                  // editable={this.state.isSuperAdmin}
                >
                  {localizationStrings.headerName}
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="150px"
                  dataSort
                  dataField="ip45SerialNumber"
                  editable={false}
                  columnTitle={columnHover}
                  thStyle={{ width: "100px" }}
                  tdStyle={{ width: "100px" }}
                  // thStyle={{ position: "relative" }}
                  // tdStyle={{ position: "relative" }}
                >
                  {localizationStrings.headerSerial}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataSort
                  dataField="Type"
                  dataFormat={this.getLockModelName}
                  editable={false}
                  columnTitle={this.getLockModelName}
                  thStyle={{ width: "150px" }}
                  tdStyle={{ width: "150px" }}
                  // thStyle={{ position: "relative" }}
                  // tdStyle={{ position: "relative" }}
                >
                  {localizationStrings.headerModel}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataSort
                  dataField="batteryLevel"
                  dataFormat={batteryFormat}
                  editable={false}
                  columnTitle={columnHover}
                  thStyle={{ width: "150px" }}
                  tdStyle={{ width: "150px" }}
                  // thStyle={{ position: "relative" }}
                  // tdStyle={{ position: "relative" }}
                >
                  {localizationStrings.headerBattery}
                </TableHeaderColumn>

                <TableHeaderColumn
                  dataSort
                  dataField="sharedBy"
                  dataFormat={this.isASharedLock}
                  editable={false}
                  columnTitle={this.isASharedLock}
                  thStyle={{ width: "150px" }}
                  tdStyle={{ width: "150px" }}
                  // thStyle={{ position: "relative" }}
                  // tdStyle={{ position: "relative" }}
                >
                  {localizationStrings.headerShareBy}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataSort
                  dataField="sharingMode"
                  dataFormat={this.isASharedMode}
                  editable={false}
                  columnTitle={this.isASharedMode}
                  thStyle={{ width: "145px" }}
                  tdStyle={{ width: "145px" }}
                  // thStyle={{ position: "relative" }}
                  // tdStyle={{ position: "relative" }}
                >
                  {localizationStrings.headerShareMode}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataSort
                  dataField="accessStatus"
                  dataFormat={japaneseFormat}
                  editable={false}
                  columnTitle={columnHover}
                  thStyle={{ width: "155px" }}
                  tdStyle={{ width: "155px" }}
                  // thStyle={{ position: "relative" }}
                  // tdStyle={{ position: "relative" }}
                >
                  {localizationStrings.headerShareTimed}
                </TableHeaderColumn>
                {/* <TableHeaderColumn
              width="150px"
              dataField="access"
              dataFormat={this.renderRecurringSchedule}
              editable={false}
              columnTitle={this.renderRecurringSchedule}
              thStyle={{ width: "170px" }}
              tdStyle={{ width: "170px" }}
              // thStyle={{ position: "relative" }}
              // tdStyle={{ position: "relative" }}
            >
              {localizationStrings.headerRecurring}
            </TableHeaderColumn> */}
                <TableHeaderColumn
                  width="150px"
                  dataField="shareAccessToken"
                  dataFormat={this.renderDetailsBtn}
                  editable={false}
                  thStyle={{ width: "100px" }}
                  tdStyle={{ width: "100px" }}
                  // thStyle={{ position: "relative" }}
                  // tdStyle={{ position: "relative" }}
                >
                  {localizationStrings.headerPermission}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="isAdmin"
                  editable={false}
                  dataSort={true}
                  dataFormat={this.tagDetailBtn}
                  columnTitle={this.tagDetailBtn}
                  width="200px"
                >
                  {localizationStrings.headerTagPasscodeInformation}
                </TableHeaderColumn>
                {/* <TableHeaderColumn
                dataField="isSuperAdmin"
                editable = {false}
                dataSort={true}
                dataFormat={this.checklockPass}
                columnTitle={this.checklockPass}
                width="200px"
              >
                {localizationStrings.headerpassword}
              </TableHeaderColumn> */}
              </BootstrapTable>
            </div>

            {/* )} */}
            {this.state.isDeleteMode ? this.renderDeleteBtn() : ""}
            {/* //! Popup for Help Button */}
            <Modal
              show={this.state.showHelpPopup}
              onHide={this.handleHelpPopupClose}
              dialogClassName="modal-90w"
            >
              <Modal.Header closeButton>
                <Modal.Title>{this.state.popupTitle}</Modal.Title>
              </Modal.Header>
              <Modal.Body>{this.state.popupImage}</Modal.Body>
            </Modal>
            {/* //! Popup for Low Battery Locks Link */}
            <Modal
              show={this.state.showLowBatteryPopup === true}
              onHide={this.handleLowBatteryPopupClose}
              dialogClassName="modal-90w"
            >
              <Modal.Header
                style={{ backgroundColor: "#ff5f5f", color: "white" }}
                closeButton
              >
                <Modal.Title>{localizationStrings.lowBatteryLocks}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <FormGroup>
                    <Checkbox
                      inline
                      checked={this.state.checkboxChecked}
                      onChange={this.handleCheck}
                    >
                      {localizationStrings.doNotShowCheckbox}
                    </Checkbox>
                    <div style={{ marginTop: "30px" }}></div>
                    {/* Move the filter logic inside the return statement */}
                    {
                      <BootstrapTable
                        id="table"
                        pagination={true}
                        bordered={false}
                        data={this.state.locklistArray.filter(
                          (lock) => lock.batteryLevel <= 15, // Change 15 to the desired low battery level threshold
                        )}
                        selectRow={{
                          bgColor: "#eeeeee",
                          mode: "checkbox",
                        }}
                        options={options2}
                        loading={this.state.loading}
                        cellEdit={{
                          mode: "dbclick",
                          blurToSave: true,
                          afterSaveCell: this.saveCellChanges,
                        }}
                        className="shareModeWordWrap timedAccessWordWrap shareByEllipsis horizontalScrollFade stickyColumn"
                        tableStyle={{
                          overflowX: "scroll",
                          tableLayout: "auto",
                          width: "100%",
                          display: "block",
                        }}
                      >
                        <TableHeaderColumn
                          dataSort
                          dataField="key"
                          isKey={true}
                          hidden
                        />
                        <TableHeaderColumn
                          dataSort
                          dataField="Name"
                          editable={this.isOwner}
                          columnTitle={(cell, row, enumObject, rowIndex) =>
                            cell
                          }
                          thStyle={{ width: "190px" }}
                          tdStyle={{ width: "190px", height: "80px" }}
                        >
                          {localizationStrings.headerName}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          width="150px"
                          dataSort
                          dataField="ip45SerialNumber"
                          editable={false}
                          columnTitle={columnHover}
                          thStyle={{ width: "100px" }}
                          tdStyle={{ width: "100px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerSerial}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="Type"
                          dataFormat={this.getLockModelName}
                          editable={false}
                          columnTitle={this.getLockModelName}
                          thStyle={{ width: "150px" }}
                          tdStyle={{ width: "150px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerModel}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="batteryLevel"
                          dataFormat={batteryFormat}
                          editable={false}
                          columnTitle={columnHover}
                          thStyle={{ width: "150px" }}
                          tdStyle={{ width: "150px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerBattery}
                        </TableHeaderColumn>

                        <TableHeaderColumn
                          dataSort
                          dataField="sharedBy"
                          dataFormat={this.isASharedLock}
                          editable={false}
                          columnTitle={this.isASharedLock}
                          thStyle={{ width: "150px" }}
                          tdStyle={{ width: "150px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerShareBy}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="sharingMode"
                          dataFormat={this.isASharedMode}
                          editable={false}
                          columnTitle={this.isASharedMode}
                          thStyle={{ width: "145px" }}
                          tdStyle={{ width: "145px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerShareMode}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="accessStatus"
                          dataFormat={japaneseFormat}
                          editable={false}
                          columnTitle={columnHover}
                          thStyle={{ width: "155px" }}
                          tdStyle={{ width: "155px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerShareTimed}
                        </TableHeaderColumn>
                        {/* <TableHeaderColumn
                            width="150px"
                            dataField="access"
                            dataFormat={this.renderRecurringSchedule}
                            editable={false}
                            columnTitle={this.renderRecurringSchedule}
                            thStyle={{ width: "170px" }}
                            tdStyle={{ width: "170px" }}
                            // thStyle={{ position: "relative" }}
                            // tdStyle={{ position: "relative" }}
                            >
                            {localizationStrings.headerRecurring}
                            </TableHeaderColumn> */}
                        <TableHeaderColumn
                          width="150px"
                          dataField="shareAccessToken"
                          dataFormat={this.renderDetailsBtn}
                          editable={false}
                          thStyle={{ width: "100px" }}
                          tdStyle={{ width: "100px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerPermission}
                        </TableHeaderColumn>
                      </BootstrapTable>
                    }
                  </FormGroup>
                </Form>
              </Modal.Body>
            </Modal>
            <Modal
              show={this.state.showExportPopup}
              onHide={this.handlePopupClose}
              dialogClassName="modal-90w"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {/* Export All Locks */}
                  {localizationStrings.exportCSVHeader}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <BootstrapTable
                  id="table"
                  pagination={true}
                  bordered={false}
                  data={this.state.locklistArray}
                  options={{
                    paginationSize: 10,
                    hideSizePerPage: true,
                    noDataText: localizationStrings.noDataTitle,
                  }}
                  loading={this.state.loading}
                  className="shareModeWordWrap timedAccessWordWrap shareByEllipsis horizontalScrollFade"
                  tableStyle={{
                    overflowX: "scroll",
                    tableLayout: "auto",
                    width: "100%",
                    display: "block",
                  }}
                >
                  <TableHeaderColumn
                    dataSort
                    dataField="key"
                    isKey={true}
                    hidden
                  />
                  <TableHeaderColumn
                    dataSort
                    dataField="Name"
                    //editable={
                    //this.isOwner
                    //}

                    columnTitle={columnHover}
                    thStyle={{ width: "190px" }}
                    tdStyle={{ width: "190px", height: "80px" }}
                    // thStyle={{ position: "absolute" }}
                    // tdStyle={{ position: "absolute" }}
                    // editable={this.state.isSuperAdmin}
                  >
                    {localizationStrings.headerName}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="150px"
                    dataSort
                    dataField="ip45SerialNumber"
                    editable={false}
                    columnTitle={columnHover}
                    thStyle={{ width: "100px" }}
                    tdStyle={{ width: "100px" }}
                    // thStyle={{ position: "relative" }}
                    // tdStyle={{ position: "relative" }}
                  >
                    {localizationStrings.headerSerial}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataSort
                    dataField="Type"
                    dataFormat={this.getLockModelName}
                    editable={false}
                    columnTitle={this.getLockModelName}
                    thStyle={{ width: "150px" }}
                    tdStyle={{ width: "150px" }}
                    // thStyle={{ position: "relative" }}
                    // tdStyle={{ position: "relative" }}
                  >
                    {localizationStrings.headerModel}
                  </TableHeaderColumn>
                  {/* <TableHeaderColumn
              dataSort
              dataField="batteryLevel"
              dataFormat={batteryFormat}
              editable={false}
              columnTitle={columnHover}
              thStyle={{ width: "150px" }}
              tdStyle={{ width: "150px" }}
              // thStyle={{ position: "relative" }}
              // tdStyle={{ position: "relative" }}
            >
              {localizationStrings.headerBattery}
            </TableHeaderColumn> */}

                  <TableHeaderColumn
                    dataSort
                    dataField="sharedBy"
                    dataFormat={this.isASharedLock}
                    editable={false}
                    columnTitle={this.isASharedLock}
                    thStyle={{ width: "150px" }}
                    tdStyle={{ width: "150px" }}
                    // thStyle={{ position: "relative" }}
                    // tdStyle={{ position: "relative" }}
                  >
                    {localizationStrings.headerShareBy}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataSort
                    dataField="sharingMode"
                    dataFormat={this.isASharedMode}
                    editable={false}
                    columnTitle={this.isASharedMode}
                    thStyle={{ width: "145px" }}
                    tdStyle={{ width: "145px" }}
                    // thStyle={{ position: "relative" }}
                    // tdStyle={{ position: "relative" }}
                  >
                    {localizationStrings.headerShareMode}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataSort
                    dataField="accessStatus"
                    dataFormat={japaneseFormat}
                    editable={false}
                    columnTitle={columnHover}
                    thStyle={{ width: "155px" }}
                    tdStyle={{ width: "155px" }}
                    // thStyle={{ position: "relative" }}
                    // tdStyle={{ position: "relative" }}
                  >
                    {localizationStrings.headerShareTimed}
                  </TableHeaderColumn>
                  {/* <TableHeaderColumn
              width="150px"
              dataField="access"
              dataFormat={this.renderRecurringSchedule}
              editable={false}
              columnTitle={this.renderRecurringSchedule}
              thStyle={{ width: "170px" }}
              tdStyle={{ width: "170px" }}
              // thStyle={{ position: "relative" }}
              // tdStyle={{ position: "relative" }}
            >
              {localizationStrings.headerRecurring}
            </TableHeaderColumn> */}
                  {/* <TableHeaderColumn
              width="150px"
              dataField="shareAccessToken"
              dataFormat={this.renderDetailsBtn}
              editable={false}
              thStyle={{ width: "100px" }}
              tdStyle={{ width: "100px" }}
              // thStyle={{ position: "relative" }}
              // tdStyle={{ position: "relative" }}
            >
              {localizationStrings.headerPermission}
            </TableHeaderColumn> */}
                  {/* <TableHeaderColumn
                dataField="isAdmin"
                editable = {false}
                dataSort={true}
                dataFormat={this.tagDetailBtn}
                columnTitle={this.tagDetailBtn}
                width="150px"
              >
                {localizationStrings.headerTagInformation}
              </TableHeaderColumn> */}
                  {/* <TableHeaderColumn
                dataField="isSuperAdmin"
                editable = {false}
                dataSort={true}
                dataFormat={this.checklockPass}
                columnTitle={this.checklockPass}
                width="150px"
              >
                {localizationStrings.headerpassword}
              </TableHeaderColumn> */}
                </BootstrapTable>
                <div
                  className="exportCSVpopupButtons"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {/* <ExportCSV /> */}
                  <button
                    className="exportButton"
                    onClick={this.handleExportCSV}
                  >
                    {/* export */}
                    {localizationStrings.exportBtnTitle}
                  </button>
                  <button
                    className="cancelButton"
                    onClick={this.handlePopupClose}
                  >
                    {/* cancel */}
                    {localizationStrings.cancelExportBtnTitle}
                  </button>
                </div>
              </Modal.Body>
            </Modal>
            <div style={{ height: "80px" }}></div>
          </TabPanel>

          {/* group */}

          <TabPanel>
            <LockGroupManagement />

            {/* <div className="group-locks">
            {localizationStrings.groupLocksDesc}
   </div>

            <div className="noDelete">{this.hasGroupLocks()}</div>

            <div>
              <BootstrapTable
                id="table"
                pagination={true}
                search
                bordered={false}
                data={this.state.grouplocklistArray}
                // selectRow={groupselectRow}
                options={options}
                loading={this.state.loading}
                // cellEdit={cellEditProp}
                className="shareModeWordWrap timedAccessWordWrap shareByEllipsis horizontalScrollFade "
                tableStyle={{
                  overflowX: "scroll",
                  tableLayout: "auto",
                  width: "100%",
                  display: "block",
                }}

                // tableStyle={{ display: "block", width: "100%", overflowX: "auto", whiteSpace: "nowrap" }}
              >
                <TableHeaderColumn
                  dataSort
                  dataField="key"
                  isKey={true}
                  hidden
                />
                <TableHeaderColumn
                  dataSort
                  dataField="Name"
                  columnTitle={columnHover}
                  thStyle={{ width: "190px" }}
                  tdStyle={{
                    width: "190px",
                    height: "80px",
                    backgroundColor: " rgb(238, 238, 238)",
                  }}
                  // thStyle={{ position: "absolute" }}
                  // tdStyle={{ position: "absolute" }}
                  // editable={this.state.isSuperAdmin}
                >
                  {localizationStrings.headerName}
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="150px"
                  dataSort
                  dataField="ip45SerialNumber"
                  editable={false}
                  columnTitle={columnHover}
                  thStyle={{ width: "100px" }}
                  tdStyle={{ width: "100px", backgroundColor: "white" }}

                  // thStyle={{ position: "relative" }}
                  // tdStyle={{ position: "relative" }}
                >
                  {localizationStrings.headerSerial}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataSort
                  dataField="Type"
                  dataFormat={this.getLockModelName}
                  editable={false}
                  columnTitle={this.getLockModelName}
                  thStyle={{ width: "150px" }}
                  tdStyle={{ width: "150px" }}
                  // thStyle={{ position: "relative" }}
                  // tdStyle={{ position: "relative" }}
                >
                  {localizationStrings.headerModel}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataSort
                  dataField="batteryLevel"
                  dataFormat={batteryFormat}
                  editable={false}
                  columnTitle={columnHover}
                  thStyle={{ width: "150px" }}
                  tdStyle={{ width: "150px" }}
                  // thStyle={{ position: "relative" }}
                  // tdStyle={{ position: "relative" }}
                >
                  {localizationStrings.headerBattery}
                </TableHeaderColumn>

            <TableHeaderColumn
              dataSort
              dataField="sharedBy"
              dataFormat={this.isASharedLock}
              editable={false}
              columnTitle={this.isASharedLock}
              thStyle={{ width: "200px" }}
              tdStyle={{ width: "200px" }}
              // thStyle={{ position: "relative" }}
              // tdStyle={{ position: "relative" }}
            >
              {localizationStrings.headerAdmin}
            </TableHeaderColumn>
            
            <TableHeaderColumn
              dataSort
              dataField="groupName"
              editable={false}
              thStyle={{ width: "150px" }}
              tdStyle={{ width: "150px" }}
              // thStyle={{ position: "relative" }}
              // tdStyle={{ position: "relative" }}
            >
              {localizationStrings.headerGroupName}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataSort
              dataField="sharingMode"
              dataFormat={this.isAGroupSharedMode}
              editable={false}
              columnTitle={this.isAGroupSharedMode}
              thStyle={{ width: "145px" }}
              tdStyle={{ width: "145px" }}
              // thStyle={{ position: "relative" }}
              // tdStyle={{ position: "relative" }}
            >
              {localizationStrings.headerShareMode}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataSort
              dataField="accessStatus"
              dataFormat={japaneseFormat}
              editable={false}
              columnTitle={columnHover}
              thStyle={{ width: "270px" }}
              tdStyle={{ width: "270px" }}
              // thStyle={{ position: "relative" }}
              // tdStyle={{ position: "relative" }}
            >
              {localizationStrings.headerShareTimed}
            </TableHeaderColumn>
         
            <TableHeaderColumn
              width="150px"
              dataField="shareAccessToken"
              dataFormat={this.groupRenderDetailsBtn}
              editable={false}
              thStyle={{ width: "100px" }}
              tdStyle={{ width: "100px" }}
              // thStyle={{ position: "relative" }}
              // tdStyle={{ position: "relative" }} 
            >
              {localizationStrings.headerPermission}
            </TableHeaderColumn>

          </BootstrapTable>
        </div>
        





                            
        {/* )} */}
            {/* {this.state.isDeleteMode ? this.renderDeleteBtn() : ""}  */}
            {/* //! Popup for Help Button */}

            <Modal
              show={this.state.showHelpPopup}
              onHide={this.handleHelpPopupClose}
              dialogClassName="modal-90w"
            >
              <Modal.Header closeButton>
                <Modal.Title>{this.state.popupTitle}</Modal.Title>
              </Modal.Header>
              <Modal.Body>{this.state.popupImage}</Modal.Body>
            </Modal>
            {/* //! Popup for Low Battery Locks Link */}
            <Modal
              show={this.state.showLowBatteryPopup === true}
              onHide={this.handleLowBatteryPopupClose}
              dialogClassName="modal-90w"
            >
              <Modal.Header
                style={{ backgroundColor: "#ff5f5f", color: "white" }}
                closeButton
              >
                <Modal.Title>{localizationStrings.lowBatteryLocks}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <FormGroup>
                    <Checkbox
                      inline
                      checked={this.state.checkboxChecked}
                      onChange={this.handleCheck}
                    >
                      {localizationStrings.doNotShowCheckbox}
                    </Checkbox>
                    <div style={{ marginTop: "30px" }}></div>
                    {/* Move the filter logic inside the return statement */}
                    {
                      <BootstrapTable
                        id="table"
                        pagination={true}
                        bordered={false}
                        data={this.state.locklistArray.filter(
                          (lock) => lock.batteryLevel <= 15, // Change 15 to the desired low battery level threshold
                        )}
                        selectRow={{
                          bgColor: "#eeeeee",
                          mode: "checkbox",
                        }}
                        options={options2}
                        loading={this.state.loading}
                        cellEdit={{
                          mode: "dbclick",
                          blurToSave: true,
                          afterSaveCell: this.saveCellChanges,
                        }}
                        className="shareModeWordWrap timedAccessWordWrap shareByEllipsis horizontalScrollFade stickyColumn"
                        tableStyle={{
                          overflowX: "scroll",
                          tableLayout: "auto",
                          width: "100%",
                          display: "block",
                        }}
                      >
                        <TableHeaderColumn
                          dataSort
                          dataField="key"
                          isKey={true}
                          hidden
                        />
                        <TableHeaderColumn
                          dataSort
                          dataField="Name"
                          editable={this.isOwner}
                          columnTitle={(cell, row, enumObject, rowIndex) =>
                            cell
                          }
                          thStyle={{ width: "190px" }}
                          tdStyle={{ width: "190px", height: "80px" }}
                        >
                          {localizationStrings.headerName}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          width="150px"
                          dataSort
                          dataField="ip45SerialNumber"
                          editable={false}
                          columnTitle={columnHover}
                          thStyle={{ width: "100px" }}
                          tdStyle={{ width: "100px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerSerial}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="Type"
                          dataFormat={this.getLockModelName}
                          editable={false}
                          columnTitle={this.getLockModelName}
                          thStyle={{ width: "150px" }}
                          tdStyle={{ width: "150px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerModel}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="batteryLevel"
                          dataFormat={batteryFormat}
                          editable={false}
                          columnTitle={columnHover}
                          thStyle={{ width: "150px" }}
                          tdStyle={{ width: "150px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerBattery}
                        </TableHeaderColumn>

                        <TableHeaderColumn
                          dataSort
                          dataField="sharedBy"
                          dataFormat={this.isASharedLock}
                          editable={false}
                          columnTitle={this.isASharedLock}
                          thStyle={{ width: "150px" }}
                          tdStyle={{ width: "150px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerShareBy}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="sharingMode"
                          dataFormat={this.isASharedMode}
                          editable={false}
                          columnTitle={this.isASharedMode}
                          thStyle={{ width: "145px" }}
                          tdStyle={{ width: "145px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerShareMode}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="accessStatus"
                          dataFormat={japaneseFormat}
                          editable={false}
                          columnTitle={columnHover}
                          thStyle={{ width: "155px" }}
                          tdStyle={{ width: "155px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerShareTimed}
                        </TableHeaderColumn>
                        {/* <TableHeaderColumn
                            width="150px"
                            dataField="access"
                            dataFormat={this.renderRecurringSchedule}
                            editable={false}
                            columnTitle={this.renderRecurringSchedule}
                            thStyle={{ width: "170px" }}
                            tdStyle={{ width: "170px" }}
                            // thStyle={{ position: "relative" }}
                            // tdStyle={{ position: "relative" }}
                            >
                            {localizationStrings.headerRecurring}
                            </TableHeaderColumn> */}
                        <TableHeaderColumn
                          width="150px"
                          dataField="shareAccessToken"
                          dataFormat={this.renderDetailsBtn}
                          editable={false}
                          thStyle={{ width: "100px" }}
                          tdStyle={{ width: "100px" }}
                          // thStyle={{ position: "relative" }}
                          // tdStyle={{ position: "relative" }}
                        >
                          {localizationStrings.headerPermission}
                        </TableHeaderColumn>
                      </BootstrapTable>
                    }
                  </FormGroup>
                </Form>
              </Modal.Body>
            </Modal>

            <div style={{ height: "80px" }}></div>
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(Locklist);
